import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import { APIURL, PORT, WEBSITEURL } from "../../../config/config";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CarEditGeneral from "../CarEditGeneral/CarEditGeneral";
import CarEditOldOwner from "../CarEditOldOwner/CarEditOldOwner";
import CarEditAlbum from "../CarEditAlbum/CarEditAlbum";
import CarEditPrice from "../CarEditPrice/CarEditPrice";
import CarDocList from "../CarDocList/CarDocList";
// import CarDocAdd from  "../CarDocAdd/CarDocAdd";
import CarRepairListItem from "../../CarRepair/CarRepairListItem/CarRepairListItem";
import CarExpenseForm from "../CarExpenseForm/CarExpenseForm";
import CarExpenseList from "../CarExpenseList/CarExpenseList";
import CarFeatureForm from "../CarFeatureForm/CarFeatureForm";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import * as moment from "moment";
import "moment/locale/th";
import CarOwnerForm from "../CarOwnerForm";
import Swal from "sweetalert2";
import { AlertError, AlertSuccess, AlertWarning } from "../../Alert/Alert";
import { CarUtil } from "../../../utils/carUtil";
import CarRepairEditForm from "../../CarRepair/CarRepairEditForm";
import CarRepairFile from "../../CarRepair/CarRepairFile";
import {
  checkGroupPermission,
  getFormControlName,
  getGroupPermission,
} from "../../../services/grouppermission";
import { NumberUtil } from "../../../utils/number-util";
import { save } from "save-file";
import CarRepairAfterSell from "../../CarRepair/CarRepairAfterSell";
import Loading from "../../Loading";
import parse from "html-react-parser";
// import { format } from "date-fns";
import { th } from "date-fns/locale";
import { DateUtil } from "../../../utils/dateUtil";
import { getLicienseStatuses } from "../../../services/licienseStatusService";
import { PDFUtil } from "../../../utils/pdfUtil";
import { AtBase64 } from "../../../base64/AtBase64";
import DataLog from "../../DataLog/DataLog";
import {
  getSumCostAfterSell,
  getSumCostBeforeSell,
} from "../../../services/costProfitService";

// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.vfs;

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts;
pdfMake.fonts = PDFUtil.getCustomFonts();
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const port = Number(window.env.PORT);

// menuID = 28 | ค่าซ่อมบำรุง(หลังขาย)
// 29 เอกสารขาย
class CarDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuID: [3, 18, 19, 20, 21, 22, 23, 24, 27, 28, 36, 106, 29, 2101, 2102],
      grouppermissions: [],
      user: {},
      activeTab: "1",
      car: {},
      car_id: "",
      upload_code: "",
      toggle_car_doc: false,
      car_doc_list: [],
      car_repair_list: [],
      toggle_delete_car_doc: false,
      toggle_delete_car_repair: false,
      car_repair: {},
      toggle_bill_print: false,
      toggle_car_edit_price: false,
      car_expense_list: [],
      toggle_car_expense: false,
      expense: {},
      banks: [],
      insurance_companies: [],
      insurance_types: [],
      // expense_id : 0
      form_controls: [],
      ownerLists: [],
      isModalCarOwner: false,
      actionCarOwner: "add",
      carOwner: null,
      car_sell_id: 0,
      // รับจ่ายจากการขาย
      vat_sell: 0,
      finance_commission: 0,
      car_external_commission: 0,
      sales_commission: 0,
      additional_commission: 0,
      advertising_cost: 0,
      delivery_fee: 0,
      promotion_fee: 0,
      finance_fee: 0,
      transfer_fee: 0,
      car_sell: {},
      width: 0,
      height: 0,
      toggle_car_repair_edit: false,
      //
      toggle_car_repair_file: false,
      car_sale_price_sorkorbor: 0,
      car_manual: "-",
      charge: 9059 ? "ไม่มี" : "-",
      sufferers: 9059 ? "ไม่มี" : "-",
      vat_commission: 0,
      //
      sum_down: port === 9051 ? "20" : "25,000",
      total_cost_period_call: "7,200 x 84",
      total_cost_period_call_72: "8,200 x 72",
      order_car_owner: "2",
      company_setting: null,
      is_date_fill: 0,
      cost_after_sales_service: 0,
      tax_invoice_vat: 0,
      tax_commission_amount: 0,
      tax_commission_vat: 0,
      amount_of_debt: 0,
      form_control_expense_cars: [],
      car_name_thai: "",
      sell_status_check: false,
      toggle_car_expense_sell: false,
      car_expense_sell_list: [],
      liciense_status_name: "-",
      ownerLasts: [],
      toggle_data_log_car_edit: false,
      toggle_data_log_car_price: false,
      //web_info_1 : '',
      //web_info_2 : '',
    };

    this.loadGroupPermission = this.loadGroupPermission.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleCarEdit = this.toggleCarEdit.bind(this);
    this.togglePrimaryCarEditOldOwner =
      this.togglePrimaryCarEditOldOwner.bind(this);
    this.toggleCarDocAdd = this.toggleCarDocAdd.bind(this);
    // this.deleteCarDoc = this.deleteCarDoc.bind(this)
    this.onCarRepairDelete = this.onCarRepairDelete.bind(this);
    this.toggleCarRepairDelete = this.toggleCarRepairDelete.bind(this);
    this.pushToCarRepairNew = this.pushToCarRepairNew.bind(this);
    this.toggleSorkorbor = this.toggleSorkorbor.bind(this);
    this.printOcpb = this.printOcpb.bind(this);
    this.printOcpbAtCarSale = this.printOcpbAtCarSale.bind(this);
    this.toggleCarEditPrice = this.toggleCarEditPrice.bind(this);
    this.toggleCarExpenseForm = this.toggleCarExpenseForm.bind(this);
    this.loadCarExpenseData = this.loadCarExpenseData.bind(this);
    this.loadBanks = this.loadBanks.bind(this);
    this.loadInsuranceCompanies = this.loadInsuranceCompanies.bind(this);
    this.loadInsuranceType = this.loadInsuranceType.bind(this);
    this.loadFormControls = this.loadFormControls.bind(this);
    // this.addCarDoc = this.addCarDoc.bind(this)
    this.loadCarOwnerData = this.loadCarOwnerData.bind(this);
    this.loadCarSellById = this.loadCarSellById.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    //
    this.updateCarRepairNoFile = this.updateCarRepairNoFile.bind(this);
    this.onCarRepairEditSelected = this.onCarRepairEditSelected.bind(this);
    this.toggleCarRepairEdit = this.toggleCarRepairEdit.bind(this);
    //
    this.toggleCarRepairFile = this.toggleCarRepairFile.bind(this);
    this.onCarRepairUploadFile = this.onCarRepairUploadFile.bind(this);
    this.exportCarRepairData = this.exportCarRepairData.bind(this);
    this.exportCarExpensesOtherData =
      this.exportCarExpensesOtherData.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.loadCarRepairData = this.loadCarRepairData.bind(this);
    this.loadCarById = this.loadCarById.bind(this);
    this.updateCarCostExpenseOther = this.updateCarCostExpenseOther.bind(this);
    this.loadCarRepairByRepairType = this.loadCarRepairByRepairType.bind(this);
    this.loadExpenseCarFormControls =
      this.loadExpenseCarFormControls.bind(this);
    this.toggleCarExpenseFormSell = this.toggleCarExpenseFormSell.bind(this);
    this.loadCarExpenseSellData = this.loadCarExpenseSellData.bind(this);
    this.printOcpbCarOk = this.printOcpbCarOk.bind(this);
    this.loadCarOwnerLastData = this.loadCarOwnerLastData.bind(this);
    this.printOcpbA3 = this.printOcpbA3.bind(this);
    this.printOcpbSamkor = this.printOcpbSamkor.bind(this);
  }

  handleOnChange(e) {
    let name = e.target.name;
    let val = e.target.value;
    //let web_info_1 = e.target.value;
    //let web_info_2 = e.target.value;

    this.setState({
      [name]: val,
    });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentWillMount() {
    const queryString = require("query-string");
    let car = queryString.parse(this.props.location.search);
    let car_sell_id = 0;

    if (car.car_sell_id !== undefined) {
      car_sell_id = car.car_sell_id;
      this.loadCarSellById(car_sell_id);
    }

    if (car.tab !== undefined) {
      this.setState({
        user: JSON.parse(this.props.user),
        car_id: car.car_id,
        upload_code: car.upload_code,
        activeTab: car.tab,
      });
    } else {
      this.setState({
        user: JSON.parse(this.props.user),
        car_id: car.car_id,
        upload_code: car.upload_code,
      });
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  async componentDidMount() {
    this.loadGroupPermission();
    this.loadFormControls();
    this.loadExpenseCarFormControls();

    this.loadBanks();
    this.loadInsuranceType();
    this.loadInsuranceCompanies();
    await this.loadCompanySetting();

    if (PORT === 9043) {
      this.loadCarOwnerLastData();
    }
    await this.loadCompanyLogoBase64();
    //
    this.loadCarById();
    this.loadCarDocData();
    this.loadCarRepairData();
    this.loadCarExpenseData();
    this.loadCarExpenseSellData();

    this.loadCarOwnerData();

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  async loadCompanySetting() {
    await axios.get(APIURL + "/company_setting/1").then((res) => {
      let data = res.data;
      let company_setting = data.company_setting;
      const is_date_fill = company_setting.is_date_fill;
      this.setState({
        company_setting: company_setting,
        is_date_fill: is_date_fill,
      });
    });
  }

  async loadCompanyLogoBase64() {
    let uri = APIURL + "/company_setting/logoimage/1";
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ logoBase64Img: body });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }

  loadGroupPermission() {
    let type = this.props.type;
    let menuID = this.state.menuID;
    getGroupPermission(type, menuID).then((res) => {
      if (res.data.result === "success") {
        this.setState({
          grouppermissions: res.data.grouppermissions,
        });
      }
    });
  }

  // _permission(menuID, grouppermissions) {
  // }

  loadCarSellById(car_sell_id) {
    // alert (this.state.car_sell_id)
    if (car_sell_id === 0 || car_sell_id === undefined) {
      return;
    }

    axios
      .get(APIURL + "/car_sell/" + car_sell_id)
      .then((res) => {
        let car_sell = res.data[0];
        // รายรับ
        let vat_sell = car_sell.vat_sell;
        let finance_commission = car_sell.finance_commission;
        let vat_commission = car_sell.vat_commission;
        // รายรายจ่าย
        let car_external_commission = car_sell.car_external_commission;
        let sales_commission = car_sell.sales_commission;
        let additional_commission = car_sell.additional_commission;
        let advertising_cost = car_sell.advertising_cost;
        let delivery_fee = car_sell.delivery_fee;
        let promotion_fee = car_sell.promotion_fee;
        let finance_fee = car_sell.finance_fee;
        let transfer_fee = car_sell.transfer_fee;
        let cost_after_sales_service = car_sell.cost_after_sales_service;
        let tax_invoice_vat = car_sell.tax_invoice_vat;
        let tax_commission_amount = car_sell.tax_commission_amount;
        let tax_commission_vat = car_sell.tax_commission_vat;
        let amount_of_debt = car_sell.amount_of_debt;

        let sell_status = car_sell.sell_status;
        // let car_status_id = car_sell.car_status_id
        let sell_status_check = sell_status === "close" ? true : false;

        this.setState(
          {
            car_sell: car_sell,
            car_sell_id: car_sell_id,
            vat_sell: vat_sell,
            finance_commission: finance_commission,
            car_external_commission: car_external_commission,
            sales_commission: sales_commission,
            additional_commission: additional_commission,
            advertising_cost: advertising_cost,
            delivery_fee: delivery_fee,
            promotion_fee: promotion_fee,
            finance_fee: finance_fee,
            transfer_fee: transfer_fee,
            vat_commission: vat_commission,
            cost_after_sales_service: cost_after_sales_service,
            tax_invoice_vat: tax_invoice_vat,
            tax_commission_amount: tax_commission_amount,
            tax_commission_vat: tax_commission_vat,
            sell_status_check: sell_status_check,
            amount_of_debt: amount_of_debt,
          },
          () => {
            // this.loadDataCarSellPay()
          }
        );
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ car_sell: {} });
      });
  }

  loadCarById() {
    axios
      .get(APIURL + "/car/" + this.state.car_id)
      .then((res) => {
        let car = res.data[0];
        let car_sale_price =
          car.car_sale_price === undefined ? 0 : car.car_sale_price;
        let web_info = car.web_info;
        this.setState(
          {
            car: car,
            car_sale_price_sorkorbor: car_sale_price,
            web_info: web_info,
          },
          () => {
            this.convertLicenseIdToName(car.liciense_status_id);
          }
        );
      })
      .catch((error) => {
        console.log("error:", error);
        // this.setState({car: {}})
      });
  }

  updateCarCostExpenseOther(expense_amount_sum) {
    // car_cost_expenses_other
    let data = {
      car_cost_expenses_other: expense_amount_sum,
    };
    axios
      .put(APIURL + "/car/car_cost_expenses_other/" + this.state.car_id, data)
      .then((res) => {
        if (res.status === 200) {
          this.loadCarById();
        }
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  toggleCarEdit() {
    this.setState({
      primary: !this.state.primary,
    });
  }

  togglePrimaryCarEditOldOwner() {
    this.setState({
      primarycareditowner: !this.state.primarycareditowner,
    });
  }

  toggleCarDocAdd() {
    this.setState({
      toggle_car_doc: !this.state.toggle_car_doc,
    });
  }

  toggleDeleteCarDoc() {
    this.setState({
      toggle_delete_car_doc: !this.state.toggle_delete_car_doc,
    });
  }

  // addCarDoc(event){
  //   event.preventDefault();
  //   // var that = this ;
  //   var car_id = event.target.car_id.value
  //   var car_doc_name = event.target.car_doc_name.value
  //
  //   const data = new FormData();
  //   data.append('file', event.target.car_doc_file.files[0], event.target.car_doc_file.files[0].name);
  //   data.append('car_id', car_id);
  //   data.append('car_doc_name', car_doc_name);
  //   data.append('user_created', this.state.user.user);
  //
  //   axios.post(APIURL+'/car_doc2',data)
  //     .then( res => {
  //       this.loadCarDocData()
  //       this.toggleCarDocAdd()
  //     })
  //
  // }

  loadCarDocData() {
    axios
      .get(APIURL + "/car_doc/car/" + this.state.car_id)
      .then((res) => {
        this.setState({ car_doc_list: res.data });
      })
      .catch((error) => {
        this.setState({ car_doc_list: [] });
      });
  }

  // deleteCarDoc(car_doc){
  //   //alert("deleteCarDoc="+car_doc.car_doc_id)
  //   this.setState({
  //      car_doc_delete: car_doc
  //   },()=>{
  //       this.toggleDeleteCarDoc()
  //   })
  // }

  onCarRepairDelete(car_repair) {
    this.setState({ car_repair: car_repair }, () =>
      this.toggleCarRepairDelete()
    );
  }

  toggleCarRepairDelete() {
    this.setState({
      toggle_delete_car_repair: !this.state.toggle_delete_car_repair,
    });
  }

  carRepairDeleteConfirm(car_repair) {
    //alert("carRepairDeleteConfirm="+id)
    var that = this;
    axios
      .put(APIURL + "/car_repair/" + car_repair.car_repair_id, {
        car_id: car_repair.car_id,
        car_repair_cost: car_repair.car_repair_cost,
        car_repair_file: car_repair.car_repair_file,
      })
      .then((res) => {
        if (res.status === 200) {
          that.loadCarRepairData();
          that.toggleCarRepairDelete();
        }
      });
  }

  onCarRepairEditSelected(car_repair) {
    this.setState({ car_repair: car_repair }, () => this.toggleCarRepairEdit());
  }

  toggleCarRepairEdit() {
    this.setState({
      toggle_car_repair_edit: !this.state.toggle_car_repair_edit,
    });
  }

  onCarRepairUploadFile(car_repair) {
    this.setState({ car_repair: car_repair }, () => this.toggleCarRepairFile());
  }

  toggleCarRepairFile() {
    let toggle = !this.state.toggle_car_repair_file;
    this.setState(
      {
        toggle_car_repair_file: toggle,
      },
      () => {
        if (toggle === false) {
          this.setState({
            car_repair: {},
          });
        }
      }
    );
  }

  updateCarRepairNoFile(event, car_repair_data) {
    event.preventDefault();
    let that = this;

    let car_repair_id = event.target.car_repair_id.value;
    let car_repair_name = event.target.car_repair_name.value;
    // let car_repair_cost = event.target.car_repair_cost.value
    let center_id = event.target.center_id.value;
    // let car_repair_send = event.target.car_repair_send.value
    // let car_repair_complete = event.target.car_repair_complete.value
    let car_id = this.state.car_id;

    let car_repair_send = car_repair_data.car_repair_send;
    let car_repair_complete = car_repair_data.car_repair_complete;
    let car_repair_cost = car_repair_data.car_repair_cost;
    let is_pickup = car_repair_data.is_pickup;
    let pickup_date = car_repair_data.pickup_date;
    let repair_type_id = car_repair_data.repair_type_id;
    let car_repair_note = car_repair_data.car_repair_note;
    let car_repair_vat = car_repair_data.car_repair_vat;

    let data = {
      car_repair_id: car_repair_id,
      car_repair_name: car_repair_name,
      car_repair_cost: car_repair_cost,
      center_id: center_id,
      car_repair_send: car_repair_send,
      car_repair_complete: car_repair_complete,
      car_id: car_id,
      user_updated: this.state.user.user,
      is_pickup,
      pickup_date,
      repair_type_id,
      car_repair_note,
      car_repair_vat,
    };

    axios
      .put(APIURL + "/car_repair/edit/" + car_repair_id, data)
      .then((res) => {
        let result = res.data.result;
        if (result === "success") {
          AlertSuccess("แก้ไขการซ่อมเรียบร้อยแล้ว");
          this.setState(
            {
              toggle_car_repair_edit: false,
            },
            () => {
              that.loadCarRepairData();
            }
          );
        }
      })
      .catch((err) => {
        console.log("error: ", err);
      });
  }

  loadCarRepairData() {
    let is_after_sell = 0;
    let car_id = this.state.car_id;
    axios
      .get(APIURL + "/car_repair/car/" + car_id + "/" + is_after_sell)
      .then((res) => {
        let list = res.data;
        let type = this.state.user.type;

        if (PORT === 9021 && type === "sale") {
          // สมพง เซลล์แสดงเฉพาะแจ้งซ่อม
          list = res.data.filter((list) => list.center_id === 32);
        }

        this.setState({ car_repair_list: list });
      })
      .catch((error) => {
        // alert("error"+error)
        this.setState({ car_repair_list: [] });
      });
  }

  loadCarRepairByRepairType(repair_type_id) {
    let is_after_sell = 0;
    let car_id = this.state.car_id;
    let data = {
      repair_type_id: repair_type_id,
      car_id: car_id,
      is_after_sell: is_after_sell,
    };

    this.setState({
      isLoading: true,
    });

    axios
      .post(APIURL + "/car_repair/repair_type", data)
      .then((res) => {
        this.setState({ car_repair_list: res.data, isLoading: false });
      })
      .catch((error) => {
        // alert("error"+error)
        this.setState({ car_repair_list: [] });
      });
  }

  pushToCarRepairNew() {
    let sell_status_check = this.state.sell_status_check;
    if (sell_status_check) {
      AlertError("ไม่สามารถเพิ่มค่าซ่อมบำรุงได้ เนื่องจากปิดการขายแล้ว");
      return;
    }

    let car_sell_id = this.state.car_sell_id;

    let is_after_sell = car_sell_id === 0 ? 0 : 1;
    let target =
      "/car-repair/new?car_id=" +
      this.state.car_id +
      "&toggle=new&is_after_sell=" +
      is_after_sell;
    this.props.history.push(target);
  }

  toggleSorkorbor() {
    // for dev
    // let __DEV__ = true;
    // console.log('__DEV__', __DEV__);
    // if (__DEV__) {
    //   this.refs.sum_down = '25,000'
    //   this.refs.total_cost_period_call = '7,200 x 84'
    //   this.refs.order_car_owner = '2'
    // }
    //ดาวน์ 20 บาท / งวด 10,940 x 84
    let web_info = this.state.web_info;
    let web_info_1 = "";
    let web_info_2 = "";

    if (PORT === 9051) {
      //web_info_1 = web_info.slice(6, -22) //เลข 20
      //web_info_2 = web_info.slice(18).trim()
      let arr_web_in = web_info.split("/");

      if (arr_web_in.length === 2) {
        web_info_2 = arr_web_in[1].trim();
      }

      let first = CarUtil.findFirstNumber(web_info);
      if (first === 0) {
        web_info_2 = web_info;
      }
      this.setState({
        //sum_down : web_info_1,
        total_cost_period_call: web_info_2,
      });
    }

    // todo : set เจ้าของรถลำดับที่
    // order_car_owner
    let car = this.state.car;
    let car_owner_old_order = car.car_owner_old_order;
    //
    if (PORT === 9043) {
      let ownerLasts = this.state.ownerLasts;
      if (ownerLasts.length !== 0) {
        let ownerLast = ownerLasts[0];
        car_owner_old_order = ownerLast.owner_order;
      }
    }

    this.setState({
      toggle_bill_print: !this.state.toggle_bill_print,
      order_car_owner: car_owner_old_order,
    });
  }

  toggleCarEditPrice() {
    this.setState({
      toggle_car_edit_price: !this.state.toggle_car_edit_price,
    });
  }

  toggleCarExpenseForm() {
    let sell_status_check = this.state.sell_status_check;
    if (sell_status_check) {
      AlertError(
        "ไม่สามารถเพิ่มค่าใช้จ่ายอื่นๆ ของรถได้ เนื่องจากปิดการขายแล้ว"
      );
      return;
    }

    this.setState({
      toggle_car_expense: !this.state.toggle_car_expense,
    });
  }

  toggleCarExpenseFormSell() {
    let sell_status_check = this.state.sell_status_check;
    if (sell_status_check) {
      AlertError(
        "ไม่สามารถเพิ่มค่าใช้จ่ายในการขาย ของรถได้ เนื่องจากปิดการขายแล้ว"
      );
      return;
    }

    this.setState({
      toggle_car_expense_sell: !this.state.toggle_car_expense_sell,
    });
  }

  loadCarExpenseData() {
    let url = APIURL + "/expense/car_id/" + this.state.car_id;
    axios
      .get(url) // 1 = ค่าใช้จ่ายอื่นๆ ของรถ
      .then((res) => {
        let car_cost_expenses_other = this.state.car.car_cost_expenses_other;
        let car_expense_list = res.data;
        let expense_amount_sum = car_expense_list.reduce((prev, expense) => {
          if (expense.include_vat === 1) {
            return prev + expense.expense_amount;
          } else {
            return (
              prev + expense.expense_amount + Number(expense.expense_amount_vat)
            );
          }
        }, 0);

        if (car_cost_expenses_other !== expense_amount_sum) {
          // update car_cost_expenses_other ถ้าค่าไม่ตรงกัน
          this.updateCarCostExpenseOther(expense_amount_sum);
        }

        this.setState({ car_expense_list: car_expense_list });
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ car_expense_list: [] });
      });
  }

  loadCarExpenseSellData() {
    // 4 = ค่าใช้จ่ายในการขาย
    let url = APIURL + "/expense/expense_sell/" + this.state.car_id;
    axios
      .get(url)
      .then((res) => {
        // let car_cost_expenses_other = this.state.car.car_cost_expenses_other
        let car_expense_list = res.data;
        let expense_amount_sum = car_expense_list.reduce((prev, expense) => {
          if (expense.include_vat === 1) {
            return prev + expense.expense_amount;
          } else {
            return (
              prev + expense.expense_amount + Number(expense.expense_amount_vat)
            );
          }
        }, 0);

        // if (car_cost_expenses_other !== expense_amount_sum) {
        // update car_cost_expenses_other ถ้าค่าไม่ตรงกัน
        // this.updateCarCostExpenseOther(expense_amount_sum)
        // }

        this.setState({ car_expense_sell_list: car_expense_list });
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ car_expense_sell_list: [] });
      });
  }

  loadCarOwnerData() {
    let car_id = this.state.car_id;
    let url = APIURL + "/car_owner/car_id/" + car_id;
    axios
      .get(url)
      .then((res) => {
        this.setState({ ownerLists: res.data });
      })
      .catch((error) => {
        this.setState({ ownerLists: [] });
      });
  }

  loadCarOwnerLastData() {
    let car_id = this.state.car_id;
    let url = APIURL + "/car_owner/last/" + car_id;
    axios
      .get(url)
      .then((res) => {
        this.setState({ ownerLasts: res.data });
      })
      .catch((error) => {
        this.setState({ ownerLasts: [] });
      });
  }

  loadBanks() {
    axios
      .get(APIURL + "/bank/")
      .then((res) => {
        this.setState({ banks: res.data });
      })
      .catch((error) => {
        this.setState({ banks: [] });
      });
  }

  loadInsuranceType() {
    axios
      .get(APIURL + "/insurance_type/")
      .then((res) => {
        this.setState({ insurance_types: res.data });
      })
      .catch((error) => {
        this.setState({ insurance_types: [] });
      });
  }

  loadInsuranceCompanies() {
    axios
      .get(APIURL + "/insurance_company/")
      .then((res) => {
        this.setState({ insurance_companies: res.data });
      })
      .catch((error) => {
        this.setState({ insurance_companies: [] });
      });
  }

  loadFormControls() {
    let tableName = "car";
    axios
      .get(APIURL + "/form_controls/" + tableName)
      .then((res) => {
        this.setState({ form_controls: res.data });
      })
      .catch((error) => {
        this.setState({ form_controls: [] });
      });
  }

  loadExpenseCarFormControls() {
    let tableName = "expense_car";
    axios
      .get(APIURL + "/form_controls/" + tableName)
      .then((res) => {
        this.setState({ form_control_expense_cars: res.data });
      })
      .catch((error) => {
        this.setState({ form_control_expense_cars: [] });
      });
  }

  async exportCarRepairData() {
    let car_id = this.state.car_id;
    // let center_id = this.state.center_id
    // ก่อนขาย is_after_sell = 0
    let is_after_sell = 0;

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .get(
            APIURL +
              "/reportrepair/carrepairbycarexport/" +
              car_id +
              "/" +
              is_after_sell
          )
          .then(async (res) => {
            const excelBuffer = res.data.excelBuffer;
            const currentDatetime = res.data.currentDatetime;
            const fileName =
              "รายงานการซ่อมบำรุงรายคัน" + currentDatetime + ".xlsx";
            this.setState({
              isLoading: false,
            });
            await save(excelBuffer, fileName);
          })
          .catch((error) => {
            console.log("error:", error);
            // this.setState({lists: []})
          });
      }
    );
  }

  async exportCarExpensesOtherData() {
    let car_id = this.state.car_id;
    //let expense_id = this.state.expense_id
    //let income_expense_item_id = this.state.income_expense_item_id
    //let branch_id = this.state.branch_id

    this.setState({
      isLoading: true,
    });

    axios
      .get(APIURL + "/reportrepair/carexpensotherbycarexport/" + car_id)
      .then(async (res) => {
        const excelBuffer = res.data.excelBuffer;
        const currentDatetime = res.data.currentDatetime;
        const carLicensePlateNew = res.data.carLicensePlateNew;
        const fileName = "คชจ.อื่นๆของรถ" + " " + carLicensePlateNew + ".xlsx";
        this.setState({
          isLoading: false,
        });
        await save(excelBuffer, fileName);
      })
      .catch((error) => {
        console.log("error:", error);
        // this.setState({lists: []})
      });
  }

  async printOcpbAtCarSale() {
    // for atcarsale จ่ายค่า dev ขึ้น
    // background: {image: 'tab', width: 861},
    let logoBase64Img = this.state.logoBase64Img;
    let company_setting = this.state.company_setting;
    let company_tel = company_setting.company_tel;
    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;

    let car_name = this.state.car.car_name;
    let car_brand_name = this.state.car.car_brand_name;
    let car_model_name = this.state.car.car_model_name;

    let car_name2 = car_brand_name + " " + car_model_name;

    let car_name_thai = this.refs.car_name_thai.value;
    if (car_name_thai === "") {
      car_name_thai = car_name2;
    }

    let car_color_name = this.state.car.car_color_name; //สี
    let car_brand_engine = this.state.car.car_brand_engine; //ยี่ห้อเครื่องยนต์

    let car_type_name = this.state.car.car_type_name; //ประเภทของรถ
    let car_type_engine_name = this.state.car.car_type_engine_name; //ชนิดเชื้อเพลิง

    let car_number =
      this.state.car.car_number === null ? "" : this.state.car.car_number; //เลขตัวรถ
    car_number = car_number.toUpperCase();
    let car_num_engines =
      this.state.car.car_num_engines === null
        ? ""
        : this.state.car.car_num_engines;
    car_num_engines = car_num_engines.toUpperCase();

    let car_license_plate_new = this.state.car.car_license_plate_new; //ทะเบียนรถยนต์
    let province_name_new = this.state.car.province_name_new;
    let car_license_plate =
      car_license_plate_new === ""
        ? province_name_new
        : car_license_plate_new + "  " + province_name_new;
    let car_mile_comma = NumberUtil.addCommasZeroInt(this.state.car.car_miles); //ระยะทางการใช้งาน

    let car_miles = NumberUtil.replaceCarMiles(car_mile_comma);

    let car_date_regis = this.state.car.car_date_regis; //วันที่จดทะเบียน
    let car_date_regis_thai = DateUtil.convertLongDateThai(car_date_regis);
    // Invalid date
    if (car_date_regis === "Invalid date" || car_date_regis === "0000-00-00") {
      car_date_regis_thai = "-";
    }

    let car_year_name = this.state.car.car_year_name; //รุ่นปี
    let car_size_engine = this.state.car.car_size_engine; //ขนาดหรือน้ำหนัก
    let order_car_owner = this.refs.order_car_owner.value;
    let car_name_owner_old = this.state.car.car_name_owner_old;
    let car_lastname_owner_old = this.state.car.car_lastname_owner_old;
    let car_owner = car_name_owner_old + "   " + car_lastname_owner_old;

    let ownerLasts = this.state.ownerLasts;
    if (ownerLasts.length !== 0) {
      // owner_name , owner_address
      let ownerLast = ownerLasts[0];
      car_owner = ownerLast.owner_name;
    }

    let charge = this.refs.charge.value;

    let car_sale_price_sorkorbor = String(this.state.car_sale_price_sorkorbor);
    let car_sale_price = NumberUtil.addCommas(car_sale_price_sorkorbor);

    let sum_down_str = String(this.refs.sum_down.value);
    let sum_down = NumberUtil.addCommas(sum_down_str);
    if (sum_down_str === "ฟรีดาวน์") {
      sum_down = sum_down_str;
    }

    let total_cost_period_call = this.refs.total_cost_period_call.value;

    if (logoBase64Img === "") {
      AlertWarning("ไม่พบไฟล์ logo");
      return;
    }

    let logo_width = 200;
    // width: logo_width
    // 330 x 125
    // fit: [330, 125]
    let headerLeft = {
      image: logoBase64Img,
      height: 98,
      width: logo_width,
    };

    let svgBox01 =
      '<svg id="eDz04KXF5CB1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 210 40" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><rect width="210" height="40" rx="8" ry="8" fill="none" stroke="#000"/> </svg>';

    let svgBox02 =
      '<svg id="eDz04KXF5CB1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 70" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><rect width="330" height="70" rx="8" ry="8" fill="none" stroke="#000"/> </svg>';

    let imgBox01 = await PDFUtil.svgToDataURL(svgBox01);
    let imgBox02 = await PDFUtil.svgToDataURL(svgBox02);

    let headerLeftTable = {
      table: {
        widths: ["100%"],
        body: [[headerLeft]],
      },
      layout: "noBorders",
    };

    let companyTel = {
      table: {
        widths: ["100%"],
        body: [
          [
            {
              text: "*** " + company_tel + " ***",
              style: "textMobile",
              margin: [0, -7, 0, 0],
            },
          ],
        ],
      },
      layout: "noBorders",
    };

    // layout: 'noBorders',
    // { svg: svgBox01, }
    let tableHeader = {
      table: {
        widths: ["30%", "40%", "30%"],
        body: [
          [
            headerLeftTable,
            {
              text: "ฉลากรถยนต์ใช้แล้ว",
              style: "headerCenter",
              margin: [0, 20, 0, 0],
            },
            {
              table: {
                widths: ["5%", "20%", "75%"],
                body: [
                  [
                    { image: imgBox01, width: 210, margin: [0, 16, 0, 0] },
                    { text: "ดาวน์", style: "body", margin: [0, 21, 0, 0] },
                    {
                      text: sum_down,
                      style: "bodyBold",
                      margin: [0, 21, 0, 0],
                    },
                  ],
                  [
                    { image: imgBox01, width: 210, margin: [0, 0, 0, 0] },
                    { text: "ผ่อน", style: "body", margin: [0, 5, 0, 0] },
                    {
                      text: total_cost_period_call,
                      style: "bodyBold",
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
          ],
        ],
      },
      layout: "noBorders",
      marginBottom: 0,
    };

    let noteFooter = {
      table: {
        widths: ["100%"],
        body: [
          [
            {
              text: "รับประกันไม่มีชนหนัก พลิกคว่ำ น้ำท่วม",
              style: "bodyBold",
              margin: [0, 0, 0, 0],
            },
          ],
          [
            {
              text:
                "ชื่อประเภทหรือชนิดสินค้า รถยนต์ใช้แล้ว ผู้ประกอบการธุรกิจ " +
                " " +
                " " +
                company_name,
              style: "small",
              margin: [0, 0, 0, 0],
            },
          ],
          [
            {
              text:
                "สถานที่ตั้งของผู้ประกอบธุรกิจ " + " " + " " + company_address,
              style: "small",
              margin: [0, 0, 0, 0],
            },
          ],
          [
            {
              text: "ขนาด/ปริมาณ " + " " + " " + car_size_engine,
              style: "small",
              margin: [0, 0, 0, 0],
            },
          ],
        ],
      },
      layout: "noBorders",
    };

    let howUseFooter = {
      table: {
        widths: ["100%"],
        body: [
          [
            {
              text:
                "วิธีใช้ข้อแนะนำการใช้" +
                " " +
                " " +
                "ควรเปลี่ยนถ่ายน้ำมันเครื่องทุก 5,000 กิโลเมตร," +
                "ควรเปลี่ยนยางเมื่อมีการสึก, ควรเปลี่ยนผ้าเบรกเมื่อมีเสียงดัง" +
                " " +
                " " +
                "คำเตือน" +
                " " +
                " " +
                "เมาไม่ขับ",
              style: "small",
              margin: [0, 0, 0, 0],
            },
          ],
        ],
      },
      layout: "noBorders",
    };

    let tableFooter = {
      table: {
        widths: ["54%", "46%"],
        body: [
          [
            noteFooter,
            {
              table: {
                widths: ["0%", "22%", "auto"],
                body: [
                  [
                    { image: imgBox02, width: 335, margin: [0, 20, 0, 0] },
                    {
                      text: "ราคา",
                      style: "priceCenter",
                      margin: [0, 27, 0, 0],
                    },
                    {
                      text: car_sale_price.toLocaleString() + " " + "บาท",
                      style: "priceCenter",
                      margin: [0, 27, 0, 0],
                    }, //car_sale_price.toLocaleString()  + '  บาท'
                  ],
                ],
              },
              layout: "noBorders",
            },
          ],
        ],
      },
      layout: "noBorders",
      marginBottom: 5,
    };

    let AtCarOcpbBG = AtBase64.getCarOcpbBG();
    let AtLineQR = AtBase64.getLineQR();

    let qrInPdf = {
      image: "lineqr",
      fit: [60, 60],
      absolutePosition: { x: 720, y: 526 },
    };

    let docDefinition = {
      pageOrientation: "landscape",
      pageSize: "A4",
      pageMargins: [20, 12, 20, 10],
      background: { image: "tab", width: 825 },
      content: [
        qrInPdf,
        tableHeader,
        companyTel,
        {
          columns: [
            { width: "auto", text: "ยี่ห้อรถ", style: "body" },
            { width: "29%", style: "bodyBold", text: car_name_thai },

            { width: "auto", text: "สี", style: "body" },
            { width: "21%", style: "bodyBold", text: car_color_name },

            { width: "auto", text: "ยี่ห้อเครื่องยนต์", style: "body" },
            { width: "auto", style: "bodyBold", text: car_brand_engine },
          ],
          columnGap: 20,
          lineHeight: 1.2,
        },
        {
          columns: [
            { width: "auto", text: "ประเภทของรถ", style: "body" },
            { width: "47%", style: "bodyBold", text: car_type_name },

            {
              width: "auto",
              text: "เชื้อเพลิง เบนซิน",
              style: "body",
              margin: [0, 0, 0, 0],
            },
            { width: "auto", style: "bodyBold", text: car_type_engine_name },
          ],
          columnGap: 20,
          lineHeight: 1.2,
        },
        {
          columns: [
            { width: "auto", text: "เลขตัวรถ", style: "body" },
            { width: "52%", style: "bodyBold", text: car_number },

            {
              width: "auto",
              text: "เลขเครื่องยนต์",
              style: "body",
              margin: [2, 0, 0, 0],
            },
            { width: "auto", style: "bodyBold", text: car_num_engines },
          ],
          columnGap: 20,
          lineHeight: 1.2,
        },
        {
          columns: [
            { width: "auto", text: "เลขทะเบียน", style: "body" },
            { width: "50%", style: "bodyBold", text: car_license_plate },

            {
              width: "auto",
              text: "ระยะทางในการใช้งาน",
              style: "body",
              margin: [-2, 0, 0, 0],
            },
            { width: "auto", style: "bodyBold", text: car_miles },
          ],
          columnGap: 20,
          lineHeight: 1.2,
        },
        {
          columns: [
            { width: "auto", text: "วันที่จดทะเบียน", style: "body" },
            { width: "47%", style: "bodyBold", text: car_date_regis_thai },

            {
              width: "auto",
              text: "รุ่นปีรถ",
              style: "body",
              margin: [-5, 0, 0, 0],
            },
            { width: "auto", style: "bodyBold", text: car_year_name },
          ],
          columnGap: 20,
          lineHeight: 1.2,
        },
        {
          columns: [
            { width: "auto", text: "เจ้าของรถลำดับที่", style: "body" },
            {
              width: "5%",
              style: "bodyBold",
              text: order_car_owner,
              //text: 'order_car_owner',
            },

            { width: "auto", text: "ชื่อ - นามสกุล", style: "body" },
            { width: "auto", style: "bodyBold", text: car_owner },
          ],
          columnGap: 20,
          lineHeight: 1.2,
        },
        {
          columns: [
            {
              width: "auto",
              text: "ภาระผูกพันของรถยนต์ที่มีในวันจำหน่าย (ถ้ามี)",
              style: "body",
            },
            { width: "auto", style: "bodyBold", text: charge },
          ],
          columnGap: 20,
          lineHeight: 1.0,
        },

        tableFooter,
        howUseFooter,
      ],

      images: {
        tab: AtCarOcpbBG,
        lineqr: AtLineQR,
      },

      styles: {
        headerCenter: {
          fontSize: 46,
          bold: true,
          alignment: "center",
          color: "#ff0000",
        },
        textMobile: {
          fontSize: 24,
          bold: true,
          color: "#ff0000",
          alignment: "left",
        },
        body: {
          fontSize: 26,
        },
        bodyBold: {
          fontSize: 26,
          bold: true,
        },
        small: {
          fontSize: 15,
        },
        priceCenter: {
          fontSize: 50,
          bold: true,
          alignment: "center",
          color: "#ff0000",
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  printOcpb() {
    // var car_name = this.state.car.car_name //ยี่ห้อรถ
    let car_sale_price_sorkorbor = String(this.state.car_sale_price_sorkorbor);
    let car_sale_price = NumberUtil.addCommas(car_sale_price_sorkorbor);
    // let car_sale_price = this.state.car.car_sale_price //ราคาขาย
    let car_name = this.state.car.car_name; //ชื่อรถ
    let car_year_name = this.state.car.car_year_name; //รุ่นปี
    let car_color_name = this.state.car.car_color_name; //สี
    let car_type_name = this.state.car.car_type_name; //ประเภทของรถ
    let car_number =
      this.state.car.car_number === null ? "" : this.state.car.car_number; //เลขตัวรถ
    car_number = car_number.toUpperCase();
    let car_num_engines =
      this.state.car.car_num_engines === null
        ? ""
        : this.state.car.car_num_engines; //เลขเครื่องยนต์
    car_num_engines = car_num_engines.toUpperCase();
    let car_brand_engine = this.state.car.car_brand_engine; //ยี่ห้อเครื่องยนต์
    let car_type_engine_name = this.state.car.car_type_engine_name; //ชนิดเชื้อเพลิง
    //var car_date_regis = this.state.car.car_date_regis
    // let car_date_regis = moment(this.state.car.car_date_regis).locale('th').format('LL')//วันที่จดทะเบียน
    let car_date_regis = this.state.car.car_date_regis; //วันที่จดทะเบียน
    let car_date_regis_thai = DateUtil.convertLongDateThai(car_date_regis);
    // Invalid date
    if (car_date_regis === "Invalid date" || car_date_regis === "0000-00-00") {
      car_date_regis_thai = "-";
    }

    let car_license_plate_new =
      this.state.car.car_license_plate_new === null
        ? ""
        : this.state.car.car_license_plate_new; //ทะเบียนรถยนต์
    let province_name_new = this.state.car.province_name_new;

    let car_license_plate_old = this.state.car.car_license_plate_old; //ทะเบียนรถยนต์
    let province_name_old = this.state.car.province_name_old;

    let car_miles = this.state.car.car_miles; //ระยะทางการใช้งาน

    if (Number(car_miles) === 0) {
      car_miles = "-";
    } else {
      let car_mile_with_comma = NumberUtil.addCommas(car_miles);
      car_miles = car_mile_with_comma + " กม.";
    }

    let car_size_engine = this.state.car.car_size_engine; //ขนาดหรือน้ำหนัก
    let car_weight = this.state.car.car_weight; //ขนาดหรือน้ำหนัก
    let car_name_owner_old = this.state.car.car_name_owner_old;
    let car_lastname_owner_old = this.state.car.car_lastname_owner_old;

    let car_license_plate =
      car_license_plate_new === ""
        ? car_license_plate_old + " " + province_name_old
        : car_license_plate_new + "  " + province_name_new;

    let order_car_owner = this.refs.order_car_owner.value;
    let car_manual = this.refs.car_manual.value;
    let charge = this.refs.charge.value;
    let sufferers = this.refs.sufferers.value;
    let car_brance = this.state.car.branch_name;
    let car_brance_address = this.state.car.branch_address;
    let branch_tel = this.state.car.branch_tel;

    let branch_name = car_brance + " (" + branch_tel + ")";

    let sum_down_str = String(this.refs.sum_down.value);
    let sum_down = NumberUtil.addCommas(sum_down_str);

    let total_cost_period_call = this.refs.total_cost_period_call.value;

    let car_brand_name = this.state.car.car_brand_name;
    let car_model_name = this.state.car.car_model_name;
    let car_sub_model_name = this.state.car.car_sub_model_name;

    let car_model_name_arr = car_model_name.split(" ");
    if (car_model_name_arr.length > 1) {
      car_model_name = car_model_name_arr[0];
    }

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (port === 9008) {
      car_name2 = car_name;
    } else {
      if (car_sub_model_name.indexOf(car_model_name) !== -1) {
        // มีชื่อรุ่นใน รุ่นย่อย
        car_name2 = car_brand_name + " " + car_sub_model_name;
      }
    }

    if (car_name2.length > 34) {
      car_name2 = car_name2.substr(0, 34);
    }

    let car_name_thai = this.refs.car_name_thai.value;
    if (car_name_thai === "") {
      car_name_thai = car_name2;
    }

    let car_owner = car_name_owner_old + "   " + car_lastname_owner_old;

    if (car_owner.length > 30) {
      car_owner = car_name_owner_old;
    }

    let car_name_len = car_owner.length;
    if (car_name_len > 30) {
      car_owner = car_owner.substr(0, 20);
    }

    let OcpbBG =
      "data:image/png;base64,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";

    let docDefinition = {
      pageOrientation: "landscape",
      pageSize: "A4",
      pageMargins: [25, 25, 25, 0],
      background: { image: "tab", width: 861 },
      content: [
        { text: "ฉลากรถยนต์ใช้แล้ว", style: "header", lineHeight: 1.2 },
        {
          columns: [
            { width: "15%", text: "ยี่ห้อรถ", style: "body" },
            { width: "50%", style: "body", text: car_name_thai },

            { width: "15%", text: "ราคา", style: "body" },
            {
              width: "20%",
              style: "body",
              text: car_sale_price.toLocaleString() + "  บาท",
            },
          ],
          columnGap: 20,
          lineHeight: 1.1,
        },
        {
          columns: [
            { width: "18%", text: "ประเภทของรถ", style: "body" },
            { width: "47%", style: "body", text: car_type_name },
            { width: "15%", text: "ดาวน์", style: "body" },
            { width: "20%", style: "body", text: sum_down + "  บาท" },
          ],

          columnGap: 20,
          lineHeight: 1.3,
        },

        {
          columns: [
            { width: "16%", text: "รุ่นปี", style: "body" },
            { width: "18%", style: "body", text: car_year_name },
            { width: "10%", text: "สีรถ", style: "body" },
            { width: "19%", style: "body", text: car_color_name },
            { width: "16%", text: "ผ่อน", style: "body" },
            { width: "21%", style: "body", text: total_cost_period_call },
          ],
          columnGap: 20,
          lineHeight: 1.3,
        },

        {
          columns: [
            { width: "15%", text: "เลขตัวรถ", style: "body" },
            { width: "38%", style: "body", text: car_number },
            { width: "18%", text: "เลขเครื่องยนต์", style: "body" },
            { width: "29%", style: "body", text: car_num_engines },
          ],

          columnGap: 20,
          lineHeight: 1.3,
        },

        {
          columns: [
            { width: "18%", text: "ยี่ห้อเครื่องยนต์", style: "body" },
            { width: "35%", style: "body", text: car_brand_engine },
            { width: "18%", text: "ชนิดเชื้อเพลิง", style: "body" },
            { width: "29%", style: "body", text: car_type_engine_name },
          ],

          columnGap: 20,
          lineHeight: 1.2,
        },

        {
          columns: [
            { width: "18%", text: "วันที่จดทะเบียน", style: "body" },
            { width: "35%", style: "body", text: car_date_regis_thai },
            { width: "16%", text: "เลขทะเบียน", style: "body" },
            { width: "31%", style: "body", text: car_license_plate },
          ],

          columnGap: 20,
          lineHeight: 1.2,
        },

        {
          columns: [
            { width: "22%", text: "ระยะทางการใช้งาน", style: "body" },
            { width: "31%", style: "body", text: car_miles },
            { width: "20%", text: "ขนาดหรือน้ำหนัก", style: "body" },
            {
              width: "27%",
              style: "body",
              text: car_size_engine + " " + car_weight,
            },
          ],

          columnGap: 20,
          lineHeight: 1.1,
        },

        {
          columns: [
            { width: "22%", text: "เจ้าของรถลำดับที่", style: "body" },
            { width: "29%", style: "body", text: order_car_owner },
            { width: "17%", text: "ชื่อ - นามสกุล", style: "body" },
            { width: "32%", style: "body", text: car_owner },
          ],

          columnGap: 20,
          lineHeight: 1.2,
        },

        {
          columns: [
            {
              width: "50%",
              text: "สมุดคู่มือการบำรุงรักษารถ (ถ้ามี)",
              style: "body",
            },
            { width: "50%", style: "body", text: car_manual },
          ],

          columnGap: 20,
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "55%",
              text: "ภาระผูกพันของรถยนต์ที่มีในวันจำหน่าย (ถ้ามี)",
              style: "body",
            },
            { width: "45%", style: "body", text: charge },
          ],

          columnGap: 20,
          lineHeight: 1.2,
        },

        {
          columns: [
            { width: "25%", text: "ข้อมูลประสบภัย (ถ้ามี)", style: "body" },
            { width: "75%", style: "body", text: sufferers },
          ],

          columnGap: 20,
          lineHeight: 1.4,
        },

        {
          columns: [
            { width: "25%", text: "ผู้ประกอบธุรกิจ", style: "bodycompany" },
            { width: "75%", style: "bodycompany", text: branch_name },
          ],

          columnGap: 20,
          lineHeight: 1,
        },

        {
          columns: [
            { width: "25%", text: "สถานที่ประกอบการ", style: "bodycompany" },
            { width: "75%", style: "bodycompany", text: car_brance_address },
          ],

          columnGap: 20,
        },
      ],

      images: {
        tab: OcpbBG,
      },
      styles: {
        header: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 26,
          bold: true,
        },
        bodycompany: {
          fontSize: 25,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };

    pdfMake.createPdf(docDefinition).open();
  }

  printOcpbA3() {
    let car_sale_price_sorkorbor = String(this.state.car_sale_price_sorkorbor);
    let car_sale_price = NumberUtil.addCommasZeroInt(car_sale_price_sorkorbor);
    let car_name = this.state.car.car_name; //ชื่อรถ
    let car_year_name = this.state.car.car_year_name; //รุ่นปี
    let car_color_name = this.state.car.car_color_name; //สี
    let car_type_name = this.state.car.car_type_name; //ประเภทของรถ
    let car_number =
      this.state.car.car_number === null ? "" : this.state.car.car_number; //เลขตัวรถ
    car_number = car_number.toUpperCase();
    let car_num_engines =
      this.state.car.car_num_engines === null
        ? ""
        : this.state.car.car_num_engines; //เลขเครื่องยนต์
    car_num_engines = car_num_engines.toUpperCase();
    let car_brand_engine = this.state.car.car_brand_engine; //ยี่ห้อเครื่องยนต์
    let car_type_engine_name =
      this.state.car.car_type_engine_name !== ""
        ? this.state.car.car_type_engine_name.replace("เครื่องยนต์", "")
        : "-";
    //let car_type_engine_name = this.state.car.car_type_engine_name //ชนิดเชื้อเพลิง
    //var car_date_regis = this.state.car.car_date_regis
    // let car_date_regis = moment(this.state.car.car_date_regis).locale('th').format('LL')//วันที่จดทะเบียน
    let car_date_regis = this.state.car.car_date_regis; //วันที่จดทะเบียน
    let car_date_regis_thai = DateUtil.convertLongDateThai(car_date_regis);
    // Invalid date
    if (car_date_regis === "Invalid date" || car_date_regis === "0000-00-00") {
      car_date_regis_thai = "-";
    }

    let car_license_plate_new =
      this.state.car.car_license_plate_new === null
        ? ""
        : this.state.car.car_license_plate_new; //ทะเบียนรถยนต์
    let province_name_new = this.state.car.province_name_new;

    let car_license_plate_old = this.state.car.car_license_plate_old; //ทะเบียนรถยนต์
    let province_name_old = this.state.car.province_name_old;

    let car_miles = this.state.car.car_miles; //ระยะทางการใช้งาน

    if (Number(car_miles) === 0) {
      car_miles = "-";
    } else {
      let car_mile_with_comma = NumberUtil.addCommasZeroInt(car_miles);
      car_miles = car_mile_with_comma + " กม.";
    }

    let car_size_engine = this.state.car.car_size_engine; //ขนาดหรือน้ำหนัก
    let car_weight = this.state.car.car_weight; //ขนาดหรือน้ำหนัก
    let car_name_owner_old = this.state.car.car_name_owner_old;
    let car_lastname_owner_old = this.state.car.car_lastname_owner_old;

    let car_license_plate =
      car_license_plate_new === ""
        ? car_license_plate_old + " " + province_name_old
        : car_license_plate_new + "  " + province_name_new;

    let order_car_owner = this.refs.order_car_owner.value;
    let car_manual = this.refs.car_manual.value;
    let charge = this.refs.charge.value;
    let sufferers = this.refs.sufferers.value;
    let car_brance = this.state.car.branch_name;
    let car_brance_address = this.state.car.branch_address;
    let branch_tel = this.state.car.branch_tel;

    let branch_name = car_brance + " (" + branch_tel + ")";

    let sum_down_str = String(this.refs.sum_down.value);
    let sum_down = NumberUtil.addCommasZeroInt(sum_down_str);

    let total_cost_period_call = this.refs.total_cost_period_call.value;

    let car_brand_name = this.state.car.car_brand_name;
    let car_model_name = this.state.car.car_model_name;
    let car_sub_model_name = this.state.car.car_sub_model_name;

    let car_model_name_arr = car_model_name.split(" ");
    if (car_model_name_arr.length > 1) {
      car_model_name = car_model_name_arr[0];
    }

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (port === 9008) {
      car_name2 = car_name;
    } else {
      if (car_sub_model_name.indexOf(car_model_name) !== -1) {
        // มีชื่อรุ่นใน รุ่นย่อย
        car_name2 = car_brand_name + " " + car_sub_model_name;
      }
    }

    if (car_name2.length > 34) {
      car_name2 = car_name2.substr(0, 34);
    }

    let car_name_thai = this.refs.car_name_thai.value;
    if (car_name_thai === "") {
      car_name_thai = car_name2;
    }

    let car_owner = car_name_owner_old + "   " + car_lastname_owner_old;

    if (car_owner.length > 30) {
      car_owner = car_name_owner_old;
    }

    let car_name_len = car_owner.length;
    if (car_name_len > 30) {
      car_owner = car_owner.substr(0, 20);
    }

    let lineWidth = 3;
    let lineCarName = {
      type: "line",
      x1: 0,
      y1: 230,
      x2: 1130,
      y2: 230,
      lineWidth: lineWidth,
      lineColor: "blue",
    };
    let lineCarName2 = {
      type: "line",
      x1: 0,
      y1: 690,
      x2: 1130,
      y2: 690,
      lineWidth: lineWidth,
      lineColor: "blue",
    };

    let canvasTopLeft = {
      canvas: [
        {
          type: "rect",
          x: 130,
          y: 64,
          w: 555,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        {
          //ราคา
          type: "rect",
          x: 840,
          y: 64,
          w: 290,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        {
          type: "rect",
          x: 130,
          y: 120,
          w: 555,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        {
          //ดาวน์
          type: "rect",
          x: 840,
          y: 120,
          w: 290,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        {
          type: "rect",
          x: 130,
          y: 175,
          w: 210,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        {
          type: "rect",
          x: 470,
          y: 175,
          w: 210,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        {
          //ผ่อน
          type: "rect",
          x: 840,
          y: 175,
          w: 290,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //lineCarName,
        //เลขตัวรถ
        {
          type: "rect",
          x: 120,
          y: 242,
          w: 410,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //เลขเครื่องยนต์ M
        {
          type: "rect",
          x: 740,
          y: 242,
          w: 390,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //ยี่ห้อเครื่องยนต์
        {
          type: "rect",
          x: 175,
          y: 298,
          w: 340,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //ชนิดเชื้อเพลิง
        {
          type: "rect",
          x: 740,
          y: 298,
          w: 390,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //วันที่จดทะเบียน
        {
          type: "rect",
          x: 175,
          y: 354,
          w: 340,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //TODx: box เลขทะเบียน
        {
          type: "rect",
          x: 685 - 16,
          y: 354,
          w: 445 + 16,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //ระยะทางการใช้งาน
        {
          type: "rect",
          x: 210,
          y: 410,
          w: 305,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //ขนาดหรือน้ำหนัก
        {
          type: "rect",
          x: 740,
          y: 410,
          w: 390,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        // TODO: box เจ้าของรถลำดับที่
        {
          type: "rect",
          x: 210,
          y: 466,
          w: 305 - 150,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //TODO: box ชื่อ - นามสกุล
        {
          type: "rect",
          x: 680 - 165,
          y: 466,
          w: 450 + 165,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //สมุดคู่มือการบำรุงรักษารถ
        {
          type: "rect",
          x: 350,
          y: 522,
          w: 780,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //ภาระผูกพัน
        {
          type: "rect",
          x: 480,
          y: 578,
          w: 650,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //ข้อมูลประสบภัย
        {
          type: "rect",
          x: 260,
          y: 634,
          w: 870,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //lineCarName2,
        //ผู้ประกอบธุรกิจ
        {
          type: "rect",
          x: 260,
          y: 702,
          w: 870,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
        //สถานที่ประกอบการ
        {
          type: "rect",
          x: 260,
          y: 758,
          w: 870,
          h: 42,
          r: 5,
          lineColor: "gray",
          color: "lightgray",
          fillOpacity: 0.85,
        },
      ],
    };
    let OcpbBG =
      "data:image/png;base64,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";

    // ตำแหน่งเริ่มต้นข้อความ คอลัม 2 5 ตัว
    let startCol2 = 580;
    let yGap = 6;
    let docDefinition = {
      pageOrientation: "landscape",
      pageSize: "A3",
      pageMargins: [30, 20, 30, 0],
      background: { image: "tab", width: 1190 },
      content: [
        canvasTopLeft,
        {
          text: "ฉลากรถยนต์ใช้แล้ว",
          style: "header",
          lineHeight: 2,
          absolutePosition: { x: 50, y: 20 },
        },
        {
          columns: [
            {
              width: "12%",
              text: "ยี่ห้อรถ",
              style: "body",
              absolutePosition: { x: 30, y: 84 },
            },
            { width: "53%", style: "bodydetail", text: car_name_thai },

            {
              width: "9%",
              text: "ราคา",
              style: "body",
              absolutePosition: { x: 765, y: 84 },
            },
            {
              width: "26%",
              style: "bodydetail",
              text: car_sale_price.toLocaleString() + " บาท",
            },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 80 - yGap },
        },
        {
          columns: [
            {
              width: "12%",
              text: "ประเภทรถ",
              style: "body",
              absolutePosition: { x: 30, y: 141 },
            },
            { width: "53%", style: "bodydetail", text: car_type_name },
            {
              width: "9%",
              text: "ดาวน์",
              style: "body",
              absolutePosition: { x: 765, y: 141 },
            },
            { width: "26%", style: "bodydetail", text: sum_down + " บาท" },
          ],
          columnGap: 20,
          lineHeight: 1.5,
          absolutePosition: { x: 30, y: 137 - yGap },
        },
        {
          columns: [
            {
              width: "16%",
              text: "รุ่นปี",
              style: "body",
              absolutePosition: { x: 30, y: 195 },
            },
            { width: "21%", style: "bodydetail", text: car_year_name },
            {
              width: "7%",
              text: "สี",
              style: "body",
              absolutePosition: { x: 450, y: 195 },
            },
            { width: "20%", style: "bodydetail", text: car_color_name },
            {
              width: "9%",
              text: "ผ่อน",
              style: "body",
              absolutePosition: { x: 765, y: 195 },
            },
            { width: "26%", style: "bodydetail", text: total_cost_period_call },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 190 - yGap },
        },
        {
          columns: [
            {
              width: "10%",
              text: "เลขตัวรถ",
              style: "body",
              absolutePosition: { x: 30, y: 262 },
            },
            { width: "43%", style: "bodydetail", text: car_number },
            {
              width: "12%",
              text: "เลขเครื่องยนต์",
              style: "body",
              absolutePosition: { x: 580, y: 262 },
            },
            { width: "35%", style: "bodydetail", text: car_num_engines },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 257 - yGap },
        },
        {
          columns: [
            {
              width: "18%",
              text: "ยี่ห้อเครื่องยนต์",
              style: "body",
              absolutePosition: { x: 30, y: 318 },
            },
            { width: "35%", style: "bodydetail", text: car_brand_engine },
            {
              width: "12%",
              text: "ชนิดเชื้อเพลิง",
              style: "body",
              absolutePosition: { x: 580, y: 318 },
            },
            { width: "35%", style: "bodydetail", text: car_type_engine_name },
          ],

          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 315 - yGap },
        },
        {
          columns: [
            {
              width: "15%",
              text: "วันที่จดทะเบียน",
              style: "body",
              absolutePosition: { x: 30, y: 374 },
            },
            { width: "34%", style: "bodydetail", text: car_date_regis_thai },
            {
              width: "8%",
              text: "เลขทะเบียน",
              style: "body",
              absolutePosition: { x: 580 - 10, y: 374 },
            },
            {
              width: "43%",
              style: "bodydetailcenter",
              text: car_license_plate,
            },
          ],

          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 370 - yGap },
        },
        {
          columns: [
            {
              width: "20%",
              text: "ระยะทางการใช้งาน",
              style: "body",
              absolutePosition: { x: 30, y: 431 },
            },
            { width: "31%", style: "bodydetail", text: car_miles },
            {
              width: "16%",
              text: "ขนาดหรือน้ำหนัก",
              style: "body",
              absolutePosition: { x: 580 - 10, y: 431 },
            },
            {
              width: "33%",
              style: "bodydetail",
              text: car_size_engine + " " + car_weight,
            },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 425 - yGap },
        },
        // TODO: เจ้าของรถลำดับที่
        {
          columns: [
            {
              width: "20%",
              text: "เจ้าของรถลำดับที่",
              style: "body",
              absolutePosition: { x: 30, y: 485 },
            },
            { width: "21%", style: "bodydetail", text: order_car_owner },
            {
              width: "8%",
              text: "ชื่อ-สกุล",
              style: "body",
              absolutePosition: { x: 580 - 140, y: 485 },
            },
            { width: "50%", style: "bodydetail", text: car_owner },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 482 - yGap },
        },
        {
          columns: [
            {
              width: "33%",
              text: "สมุดคู่มือการบำรุงรักษารถ (ถ้ามี)",
              style: "body",
              absolutePosition: { x: 30, y: 543 },
            },
            { width: "68%", style: "bodydetail", text: car_manual },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 540 - yGap },
        },
        {
          columns: [
            {
              width: "45%",
              text: "ภาระผูกพันของรถยนต์ที่มีในวันจำหน่าย (ถ้ามี)",
              style: "body",
              absolutePosition: { x: 30, y: 598 },
            },
            { width: "55%", style: "bodydetail", text: charge },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 595 - yGap },
        },
        {
          columns: [
            {
              width: "25%",
              text: "ข้อมูลประสบภัย (ถ้ามี)",
              style: "body",
              absolutePosition: { x: 30, y: 654 },
            },
            { width: "75%", style: "bodydetail", text: sufferers },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 650 - yGap },
        },
        {
          columns: [
            { width: "25%", text: "ผู้ประกอบธุรกิจ", style: "bodycompany" },
            { width: "75%", style: "bodycompany", text: branch_name },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          absolutePosition: { x: 30, y: 722 },
        },
        {
          columns: [
            { width: "25%", text: "สถานที่ประกอบการ", style: "bodycompany" },
            { width: "75%", style: "bodycompany", text: car_brance_address },
          ],
          columnGap: 20,
          absolutePosition: { x: 30, y: 779 },
        },
      ],

      images: {
        tab: OcpbBG,
      },
      styles: {
        header: {
          fontSize: 40,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 36,
          bold: true,
        },
        bodydetail: {
          fontSize: 56,
          bold: true,
        },
        bodydetailcenter: {
          fontSize: 56,
          bold: true,
          alignment: "center",
        },
        bodycompany: {
          fontSize: 36,
          bold: true,
        },
        bodycompanydetail: {
          fontSize: 40,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };

    pdfMake.createPdf(docDefinition).open();
  }

  printOcpbCarOk() {
    // carok จ่ายเพิ่ม
    // var car_name = this.state.car.car_name //ยี่ห้อรถ
    pdfMake.fonts = PDFUtil.getCustomFonts();

    let company_setting = this.state.company_setting;
    let company_tel = company_setting.company_tel;
    // let company_name = company_setting.company_name
    let company_name =
      PORT === 9059 ? "คาร์ โอเค" : company_setting.company_name;
    let company_address = company_setting.company_address;

    let car_sale_price_sorkorbor = String(this.state.car_sale_price_sorkorbor);
    let car_sale_price = NumberUtil.addCommas(car_sale_price_sorkorbor);
    // let car_sale_price = this.state.car.car_sale_price //ราคาขาย
    let car_name = this.state.car.car_name; //ชื่อรถ
    let car_year_name = this.state.car.car_year_name; //รุ่นปี
    let car_color_name = this.state.car.car_color_name; //สี
    let car_type_name = this.state.car.car_type_name; //ประเภทของรถ
    let car_number =
      this.state.car.car_number === null ? "" : this.state.car.car_number; //เลขตัวรถ
    car_number = car_number.toUpperCase();
    let car_num_engines =
      this.state.car.car_num_engines === null
        ? ""
        : this.state.car.car_num_engines; //เลขเครื่องยนต์
    car_num_engines = car_num_engines.toUpperCase();
    let car_brand_engine = this.state.car.car_brand_engine; //ยี่ห้อเครื่องยนต์
    let car_type_engine_name =
      this.state.car.car_type_engine_name !== ""
        ? this.state.car.car_type_engine_name.replace("เครื่องยนต์", "")
        : "-"; //ชนิดเชื้อเพลิง
    //var car_date_regis = this.state.car.car_date_regis
    // let car_date_regis = moment(this.state.car.car_date_regis).locale('th').format('LL')//วันที่จดทะเบียน
    let car_date_regis = this.state.car.car_date_regis; //วันที่จดทะเบียน
    let car_date_regis_thai = DateUtil.convertLongDateThai(car_date_regis);
    // Invalid date
    if (car_date_regis === "Invalid date" || car_date_regis === "0000-00-00") {
      car_date_regis_thai = "-";
    }

    let car_license_plate_new =
      this.state.car.car_license_plate_new === null
        ? ""
        : this.state.car.car_license_plate_new; //ทะเบียนรถยนต์
    let province_name_new = this.state.car.province_name_new;

    let car_license_plate_old = this.state.car.car_license_plate_old; //ทะเบียนรถยนต์
    let province_name_old = this.state.car.province_name_old;

    let car_miles = this.state.car.car_miles; //ระยะทางการใช้งาน

    if (Number(car_miles) === 0) {
      car_miles = "-";
    } else {
      let car_mile_with_comma = NumberUtil.addCommasZeroInt(car_miles);
      car_miles = car_mile_with_comma;
    }

    let car_size_engine =
      this.state.car.car_size_engine !== ""
        ? NumberUtil.addCommasZeroInt(this.state.car.car_size_engine)
        : "-"; //ขนาดหรือน้ำหนัก
    let car_weight = this.state.car.car_weight; //ขนาดหรือน้ำหนัก
    let car_name_owner_old = this.state.car.car_name_owner_old;
    let car_lastname_owner_old = this.state.car.car_lastname_owner_old;

    let license_plate_new = car_license_plate_new + " " + province_name_new;
    let license_plate_old = car_license_plate_old + " " + province_name_old;

    if (province_name_new === "นครศรีธรรมราช") {
      license_plate_new = car_license_plate_new + province_name_new;
    }

    if (license_plate_old === "นครศรีธรรมราช") {
      license_plate_old = car_license_plate_old + province_name_old;
    }

    let car_license_plate =
      car_license_plate_new === "" ? license_plate_old : license_plate_new;

    let order_car_owner = this.refs.order_car_owner.value;
    let car_manual = this.refs.car_manual.value;
    let charge = this.refs.charge.value;
    let sufferers = this.refs.sufferers.value;
    let car_brance = this.state.car.branch_name;
    let car_brance_address = this.state.car.branch_address;
    let branch_tel = this.state.car.branch_tel;

    let branch_name = car_brance + " (" + branch_tel + ")";

    let sum_down_str = String(this.refs.sum_down.value);
    let sum_down = NumberUtil.addCommas(sum_down_str);

    let total_cost_period_call = this.refs.total_cost_period_call.value;

    let car_brand_name = this.state.car.car_brand_name;
    let car_model_name = this.state.car.car_model_name;
    let car_sub_model_name = this.state.car.car_sub_model_name;

    let car_model_name_arr = car_model_name.split(" ");
    if (car_model_name_arr.length > 1) {
      car_model_name = car_model_name_arr[0];
    }

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (port === 9008) {
      car_name2 = car_name;
    } else {
      if (car_sub_model_name.indexOf(car_model_name) !== -1) {
        // มีชื่อรุ่นใน รุ่นย่อย
        car_name2 = car_brand_name + " " + car_sub_model_name;
      }
    }

    if (car_name2.length > 28) {
      car_name2 = car_name2.substr(0, 28);
    }

    let car_name_thai = this.refs.car_name_thai.value;
    if (car_name_thai === "") {
      car_name_thai = car_name2;
    }

    let car_owner = car_name_owner_old + "   " + car_lastname_owner_old;

    if (car_lastname_owner_old === "") {
      car_owner = car_name_owner_old;
    }

    // if (car_owner.length > 30) {
    //   car_owner = car_name_owner_old
    // }
    //
    // let car_name_len = car_owner.length
    // if (car_name_len > 30) {
    //   car_owner = car_owner.substr(0, 20)
    // }

    let lineWidth = 0.5;
    let lineCarName = {
      type: "line",
      x1: 135,
      y1: 62,
      x2: 860,
      y2: 62,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCarPrice = {
      type: "line",
      x1: 135,
      y1: 122,
      x2: 860,
      y2: 122,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    let x11Company = 176;
    let y1112Company = 176;
    let lineCompany11 = {
      type: "line",
      x1: x11Company,
      y1: y1112Company,
      x2: 700,
      y2: y1112Company,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCompany12 = {
      type: "line",
      x1: 894,
      y1: y1112Company,
      x2: 1170,
      y2: y1112Company,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    x11Company = 176;
    y1112Company = 176 + 30;
    let lineCompany21 = {
      type: "line",
      x1: x11Company,
      y1: y1112Company,
      x2: 700,
      y2: y1112Company,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCompany22 = {
      type: "line",
      x1: 894,
      y1: y1112Company,
      x2: 1170,
      y2: y1112Company,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    y1112Company = 176 + 60;
    let lineCompany31 = {
      type: "line",
      x1: x11Company,
      y1: y1112Company,
      x2: 700,
      y2: y1112Company,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    y1112Company = 176 + 90;
    let lineCompany41 = {
      type: "line",
      x1: x11Company,
      y1: y1112Company,
      x2: 700,
      y2: y1112Company,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    // car detail
    let x11Detail = 272;
    let y1112Detail = 342;
    let lineCarDetail11 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 512,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCarDetail12 = {
      type: "line",
      x1: 720,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    x11Detail = 272;
    y1112Detail = 342 + 63;
    let lineCarDetail21 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 800,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCarDetail22 = {
      type: "line",
      x1: 920,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    x11Detail = 272;
    y1112Detail = 342 + 63 + 63 + 2;
    let lineCarDetail31 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 800,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCarDetail32 = {
      type: "line",
      x1: 920,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    // เชื้อเพลง
    x11Detail = 272;
    y1112Detail = 342 + 63 + 63 + 63 + 2;
    let lineCarDetail41 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 800,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };
    let lineCarDetail42 = {
      type: "line",
      x1: 952,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    // ระยะทาง
    x11Detail = 272 + 140;
    y1112Detail = 342 + 63 + 63 + 63 + 63 + 2;
    let lineCarDetail51 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    // ระยะทาง
    x11Detail = 272 + 20;
    y1112Detail = 342 + 63 + 63 + 63 + 63 + 63 + 4;
    let lineCarDetail61 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    // ภาระ
    x11Detail = 272 + 620;
    y1112Detail = 342 + 63 + 63 + 63 + 63 + 63 + 63 + 6;
    let lineCarDetail71 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    // ประสบภัย
    x11Detail = 272 + 620;
    y1112Detail = 342 + 63 + 63 + 63 + 63 + 63 + 63 + 63 + 6;
    let lineCarDetail81 = {
      type: "line",
      x1: x11Detail,
      y1: y1112Detail,
      x2: 1170,
      y2: y1112Detail,
      lineWidth: lineWidth,
      lineColor: "grey",
    };

    let canvasTopLeft = {
      canvas: [
        {
          type: "rect",
          x: 0,
          y: 0,
          w: 875,
          h: 145,
          r: 20,
          lineColor: "red",
        },
        {
          type: "rect",
          x: 880,
          y: 0,
          w: 295,
          h: 145,
          r: 20,
          lineColor: "red",
        },
        {
          type: "rect",
          x: 0,
          y: 152,
          w: 1180,
          h: 130,
          r: 20,
          lineColor: "red",
        },
        {
          type: "rect",
          x: 0,
          y: 292,
          w: 1180,
          h: 524,
          r: 0,
          lineColor: "red",
        },
        lineCarName,
        lineCarPrice,
        lineCompany11,
        lineCompany12,
        lineCompany21,
        lineCompany22,
        lineCompany31,
        lineCompany41,
        lineCarDetail11,
        lineCarDetail12,
        lineCarDetail21,
        lineCarDetail22,
        lineCarDetail31,
        lineCarDetail32,
        lineCarDetail41,
        lineCarDetail42,
        lineCarDetail51,
        lineCarDetail61,
        lineCarDetail71,
        lineCarDetail81,
      ],
    };

    let layoutLowPaddingNoBorder = {
      paddingLeft: function (i, node) {
        return 10;
      },
      paddingRight: function (i, node) {
        return 10;
      },
      paddingTop: function (i, node) {
        return -6;
      },
      paddingBottom: function (i, node) {
        return -10;
      },
      hLineWidth: function (i, node) {
        return i === 0 || i === node.table.body.length ? 0 : 0;
      },
      vLineWidth: function (i, node) {
        return i === 0 || i === node.table.widths.length ? 0 : 0;
      },
    };

    let starSvg = `<svg width="64px" height="64px" viewBox="0 0 15.00 15.00" fill="none"  stroke="#d1d1d1" stroke-width="0.48"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#00000" stroke-width="0.8400000000000001"> <path d="M7.94838 0.778719C7.86415 0.60805 7.69034 0.5 7.50001 0.5C7.30969 0.5 7.13587 0.60805 7.05165 0.778719L5.00476 4.92621L0.42816 5.59081C0.239806 5.61816 0.0833166 5.75008 0.0244934 5.93109C-0.0343298 6.1121 0.0147161 6.31081 0.151008 6.44366L3.46277 9.67185L2.68076 14.2306C2.64858 14.4182 2.72569 14.6078 2.87966 14.7196C3.03364 14.8315 3.23778 14.8463 3.40624 14.7577L7.50001 12.6054L11.5938 14.7577C11.7623 14.8463 11.9664 14.8315 12.1204 14.7196C12.2743 14.6078 12.3515 14.4182 12.3193 14.2306L11.5373 9.67185L14.849 6.44366C14.9853 6.31081 15.0344 6.1121 14.9755 5.93109C14.9167 5.75008 14.7602 5.61816 14.5719 5.59081L9.99527 4.92621L7.94838 0.778719Z" fill="#000000"></path> </g><g id="SVGRepo_iconCarrier"> <path d="M7.94838 0.778719C7.86415 0.60805 7.69034 0.5 7.50001 0.5C7.30969 0.5 7.13587 0.60805 7.05165 0.778719L5.00476 4.92621L0.42816 5.59081C0.239806 5.61816 0.0833166 5.75008 0.0244934 5.93109C-0.0343298 6.1121 0.0147161 6.31081 0.151008 6.44366L3.46277 9.67185L2.68076 14.2306C2.64858 14.4182 2.72569 14.6078 2.87966 14.7196C3.03364 14.8315 3.23778 14.8463 3.40624 14.7577L7.50001 12.6054L11.5938 14.7577C11.7623 14.8463 11.9664 14.8315 12.1204 14.7196C12.2743 14.6078 12.3515 14.4182 12.3193 14.2306L11.5373 9.67185L14.849 6.44366C14.9853 6.31081 15.0344 6.1121 14.9755 5.93109C14.9167 5.75008 14.7602 5.61816 14.5719 5.59081L9.99527 4.92621L7.94838 0.778719Z" fill="#000000"></path> </g></svg>`;

    let tableTopLeft = {
      layout: layoutLowPaddingNoBorder,
      table: {
        widths: [835],
        body: [
          [
            {
              columns: [
                { text: "ยี่ห้อรถ", style: "labelFont", width: 125 },
                { text: car_name_thai, style: "contentFont", width: "auto" },
              ],
              margin: [0, 10, 0, 0],
            },
          ],
          [
            {
              columns: [
                {
                  text: "ราคา",
                  style: "labelPriceBath",
                  width: 125,
                  margin: [0, 10, 0, 0],
                },
                {
                  text: NumberUtil.addCommasZeroInt(car_sale_price),
                  style: "textPriceCenter",
                  width: 400,
                },
                {
                  text: "บาท",
                  style: "labelPriceBath",
                  width: 100,
                  margin: [0, 10, 0, 0],
                },
              ],
              margin: [0, 30, 0, 0],
              // border: [false, false, false, false],
            },
          ],
        ],
      },
      absolutePosition: { x: 10, y: 25 },
    };

    // TODx: pdf สคบ. carok
    let tableTopRight = {
      layout: layoutLowPaddingNoBorder,
      table: {
        widths: [280],
        body: [
          [
            {
              columns: [
                { text: "เครดิตดีฟรีดาวน์", style: "labelDown", width: "100%" },
              ],
            },
          ],
          [
            {
              columns: [
                {
                  image: PDFUtil.getStarImageBase64(),
                  width: 54,
                  height: 54,
                  alignment: "center",
                },
                // {
                //   svg: starSvg,
                //   fit: [54, 54],
                //   width: 54,
                //   margin: [0, 10, 0, 0]
                // },
                {
                  text: "0",
                  style: "contentDownCenter",
                  width: 135,
                  margin: [0, 20, 0, 0],
                },
                {
                  text: "บาท",
                  style: "labelBathLeft",
                  width: 30,
                  margin: [0, 55, 0, 0],
                },
                {
                  image: PDFUtil.getStarImageBase64(),
                  width: 54,
                  height: 54,
                  alignment: "center",
                },
                // {
                //   svg: starSvg,
                //   fit: [54, 54],
                //   width: 54,
                //   margin: [0, 10, 0, 0]
                // },
              ],
              margin: [0, 25, 0, 0],
            },
          ],
        ],
      },
      absolutePosition: { x: 885, y: 22 },
    };

    // รถยนต์บรรทุกส่วนบุคคล : car_type_name

    let tableCompany = {
      table: {
        widths: [1150],
        heights: [25, 25, 25, 25],
        body: [
          [
            {
              columns: [
                {
                  text: "ชื่อประเภทหรือชนิดสินค้า",
                  style: "labelCompany",
                  width: 200,
                },
                { text: car_type_name, style: "labelCompanyBold", width: 440 },
                { text: "", style: "labelCompanyBold", width: 60 },
                { text: "รถยนต์ใช้แล้ว", style: "labelCompany", width: 200 },
                { text: "-", style: "labelCompanyBold", width: 200 },
              ],
              border: [false, false, false, false],
            },
          ],
          [
            {
              columns: [
                { text: "ผู้ประกอบธุรกิจ", style: "labelCompany", width: 120 },
                { text: company_name, style: "labelCompanyBold", width: 580 },
                {
                  text: "สมุดคู่มือการบำรุงรักษารถ (ถ้ามี)",
                  style: "labelCompany",
                  width: 200,
                },
                { text: car_manual, style: "labelCompanyBold", width: 200 },
              ],
              border: [false, false, false, false],
            },
          ],
          [
            {
              columns: [
                {
                  text: "สถานที่ตั้งของผู้ประกอบธุรกิจ",
                  style: "labelCompany",
                  width: 250,
                },
                {
                  text: company_address,
                  style: "labelCompanyBoldLeft",
                  width: 450,
                },
              ],
              border: [false, false, false, false],
            },
          ],
          [
            {
              columns: [
                { text: "ขนาด/น้ำหนัก", style: "labelCompany", width: 200 },
                {
                  text: car_size_engine,
                  style: "labelCompanyBold",
                  width: 400,
                },
                { text: "ซีซี", style: "labelCompanyBoldLeft", width: 100 },
              ],
              border: [false, false, false, false],
            },
          ],
        ],
      },
      absolutePosition: { x: 18, y: 165 },
    };

    let marginTopCar = 40;
    let tableCar = {
      layout: layoutLowPaddingNoBorder,
      absolutePosition: { x: 10, y: 320 },
      table: {
        widths: [1150],
        body: [
          [
            {
              columns: [
                { text: "ยี่ห้อเครื่องยนต์", style: "labelFont", width: 245 },
                { text: car_brand_engine, style: "contentCenter", width: 260 },
                { text: "เลขทะเบียน", style: "labelFont", width: 190 },
                { text: car_license_plate, style: "contentCenter", width: "*" },
              ],
              margin: [0, 0, 0, 0],
            },
          ],
          [
            {
              columns: [
                { text: "วันจดทะเบียน", style: "labelFont", width: 300 },
                { text: car_date_regis_thai, style: "contentFont", width: 525 },
                {
                  text: "รุ่นปี",
                  style: "labelFont",
                  width: 100,
                  fillColor: "#dedede",
                },
                { text: car_year_name, style: "contentCenter", width: 200 },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
          [
            {
              columns: [
                { text: "เลขตัวถัง", style: "labelFont", width: 150 },
                { text: car_number, style: "contentCenter", width: 690 },
                { text: "สี", style: "labelFont", width: 100 },
                { text: car_color_name, style: "contentCenter", width: 200 },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
          [
            {
              columns: [
                { text: "เลขเครื่องยนต์", style: "labelFont", width: 230 },
                { text: car_num_engines, style: "contentCenter", width: 560 },
                { text: "เชื้อเพลิง", style: "labelFont", width: 138 },
                {
                  text: car_type_engine_name,
                  style: "contentCenter",
                  width: 200,
                },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
          [
            {
              columns: [
                {
                  text: "ระยะทางในการใช้รถยนต์",
                  style: "labelFont",
                  width: 425,
                },
                { text: car_miles, style: "contentCenter", width: 320 },
                { text: "กม.", style: "labelFont", width: 200 },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
          [
            {
              columns: [
                { text: "เจ้าของรถลำดับที่", style: "labelFont", width: 280 },
                { text: order_car_owner, style: "contentCenter", width: 100 },
                { text: car_owner, style: "contentFont", width: "*" },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
          [
            {
              columns: [
                {
                  text: "ภาระผูกพันของรถยนต์ที่อยู่ในวันที่จำหน่าย(ถ้ามี)",
                  style: "labelFont",
                  width: 975,
                },
                { text: sufferers, style: "contentFont", width: "auto" },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
          [
            {
              columns: [
                {
                  text: "ข้อมูลการประสบภัย(ถ้ามี)",
                  style: "labelFont",
                  width: 975,
                },
                { text: charge, style: "contentFont", width: "auto" },
              ],
              margin: [0, marginTopCar, 0, 0],
            },
          ],
        ],
      },
    };

    let docDefinition = {
      pageOrientation: "landscape",
      pageSize: "A3",
      pageMargins: [5, 5, 5, 5],
      content: [
        canvasTopLeft,
        tableTopLeft,
        tableTopRight,
        tableCompany,
        tableCar,
      ],
      styles: {
        tableMargin: {
          margin: [0, 0, 0, 0],
        },
        labelFont: {
          fontSize: 54,
          bold: true,
        },
        labelPriceBath: {
          fontSize: 60,
          bold: true,
        },
        contentFont: {
          fontSize: 60,
          bold: true,
        },
        contentCenter: {
          fontSize: 60,
          bold: true,
          alignment: "center",
        },
        textPriceCenter: {
          fontSize: 80,
          bold: true,
          alignment: "center",
        },
        labelDown: {
          fontSize: 52,
          bold: true,
        },
        contentDownCenter: {
          fontSize: 84,
          bold: true,
          alignment: "center",
        },
        labelCompany: {
          fontSize: 20,
        },
        labelCompanyBoldLeft: {
          fontSize: 20,
          bold: true,
        },
        labelCompanyBold: {
          fontSize: 20,
          bold: true,
          alignment: "center",
        },
        labelBathLeft: {
          fontSize: 18,
        },
      },
      defaultStyle: {
        font: "IrisUPC",
      },
    };

    pdfMake.createPdf(docDefinition).open();

    // Courier , THSarabunNew
    // cm1cm = 37.8px = 25.2/64in
  }

  printOcpbSamkor() {
    let logoBase64Img = this.state.logoBase64Img;
    let company_setting = this.state.company_setting;
    let company_tel = company_setting.company_tel;
    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;

    let car_sale_price_sorkorbor = String(this.state.car_sale_price_sorkorbor);
    let car_sale_price = NumberUtil.addCommasZeroInt(car_sale_price_sorkorbor);
    let car_name = this.state.car.car_name; //ชื่อรถ
    let car_year_name = this.state.car.car_year_name; //รุ่นปี
    let car_color_name = this.state.car.car_color_name; //สี
    let car_type_name = this.state.car.car_type_name; //ประเภทของรถ
    let car_number =
      this.state.car.car_number === null ? "" : this.state.car.car_number; //เลขตัวรถ
    car_number = car_number.toUpperCase();
    let car_num_engines =
      this.state.car.car_num_engines === null
        ? ""
        : this.state.car.car_num_engines; //เลขเครื่องยนต์
    car_num_engines = car_num_engines.toUpperCase();
    let car_brand_engine = this.state.car.car_brand_engine; //ยี่ห้อเครื่องยนต์
    let car_type_engine_name =
      this.state.car.car_type_engine_name !== ""
        ? this.state.car.car_type_engine_name.replace("เครื่องยนต์", "")
        : "-";
    //let car_type_engine_name = this.state.car.car_type_engine_name //ชนิดเชื้อเพลิง
    //var car_date_regis = this.state.car.car_date_regis
    // let car_date_regis = moment(this.state.car.car_date_regis).locale('th').format('LL')//วันที่จดทะเบียน
    let car_date_regis = this.state.car.car_date_regis; //วันที่จดทะเบียน
    let car_date_regis_thai = DateUtil.convertLongDateThai(car_date_regis);
    // Invalid date
    if (car_date_regis === "Invalid date" || car_date_regis === "0000-00-00") {
      car_date_regis_thai = "-";
    }

    let car_license_plate_new =
      this.state.car.car_license_plate_new === null
        ? ""
        : this.state.car.car_license_plate_new; //ทะเบียนรถยนต์
    let province_name_new = this.state.car.province_name_new;

    let car_license_plate_old = this.state.car.car_license_plate_old; //ทะเบียนรถยนต์
    let province_name_old = this.state.car.province_name_old;

    let car_miles = this.state.car.car_miles; //ระยะทางการใช้งาน

    if (Number(car_miles) === 0) {
      car_miles = "-";
    } else {
      let car_mile_with_comma = NumberUtil.addCommasZeroInt(car_miles);
      car_miles = car_mile_with_comma + " กม.";
    }

    let car_size_engine = this.state.car.car_size_engine; //ขนาดหรือน้ำหนัก
    let car_weight =
      this.state.car.car_weight !== null || this.state.car.car_weight !== ""
        ? "/" + this.state.car.car_weight
        : " "; //ขนาดหรือน้ำหนัก
    let car_name_owner_old = this.state.car.car_name_owner_old;
    let car_lastname_owner_old = this.state.car.car_lastname_owner_old;

    let car_license_plate =
      car_license_plate_new === ""
        ? car_license_plate_old + " " + province_name_old
        : car_license_plate_new + "  " + province_name_new;

    let order_car_owner = this.refs.order_car_owner.value;
    let car_manual = this.refs.car_manual.value;
    let charge = this.refs.charge.value;
    let sufferers = this.refs.sufferers.value;
    let car_brance = this.state.car.branch_name;
    let car_brance_address = this.state.car.branch_address;
    let branch_tel = this.state.car.branch_tel;

    let branch_name = car_brance + " (" + branch_tel + ")";

    let sum_down_str = String(this.refs.sum_down.value);
    let sum_down = NumberUtil.addCommasZeroInt(sum_down_str);

    let total_cost_period_call = this.refs.total_cost_period_call.value;
    let total_cost_period_call_72 = this.refs.total_cost_period_call_72.value;

    let car_brand_name = this.state.car.car_brand_name;
    let car_model_name = this.state.car.car_model_name;
    let car_sub_model_name = this.state.car.car_sub_model_name;

    // ถ้า sub_model มีชื่อ model ซ้ำอยู่ข้างใน ให้ลบ model ออกจาก sub_model
    if (car_sub_model_name.includes(car_model_name)) {
      car_sub_model_name = car_sub_model_name
        .replace(car_model_name, "")
        .trim();
    }

    // รวมชื่อทั้งหมด
    let car_name2 =
      car_brand_name +
      " " +
      car_model_name +
      (car_sub_model_name ? " " + car_sub_model_name : "");

    // ตัดชื่อถ้ายาวเกิน 34 ตัวอักษร
    if (car_name2.length > 30) {
      car_name2 = car_name2.substr(0, 30);
    }

    let car_owner = car_name_owner_old + "   " + car_lastname_owner_old;

    if (car_owner.length > 30) {
      car_owner = car_name_owner_old;
    }

    let car_name_len = car_owner.length;
    if (car_name_len > 30) {
      car_owner = car_owner.substr(0, 20);
    }

    let car_name_thai = this.refs.car_name_thai.value;
    if (car_name_thai === "") {
      car_name_thai = car_name2;
    }
    if (logoBase64Img === "") {
      AlertWarning("ไม่พบไฟล์ logo");
      return;
    }

    let logo_width = 150;
    let headerLeft = {
      image: logoBase64Img,
      height: 100,
      width: logo_width,
    };

    let headerLeftTable = {
      table: {
        widths: ["100%"],
        body: [[headerLeft]],
      },
      margin: [50, -10, 0, 0],
      layout: "noBorders",
    };

    let tableHeader = {
      table: {
        widths: ["30%", "40%", "30%"],
        margin: [0, 0, 0, 10],
        body: [
          [
            headerLeftTable,
            {
              text: "ฉลากรถยนต์ใช้แล้ว",
              style: "header",
              margin: [0, 15, 0, 0],
            },
          ],
        ],
      },
      layout: "noBorders",
    };

    let yGap = 25;
    let yGap2 = 37;

    let canvasCarName = {
      canvas: [
        {
          type: "rect",
          x: 110,
          y: 5,
          w: 610,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarPrice = {
      canvas: [
        {
          type: "rect",
          x: 810 + yGap,
          y: 5,
          w: 300,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarTypeName = {
      canvas: [
        {
          type: "rect",
          x: 110,
          y: 5,
          w: 610,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarDown = {
      canvas: [
        {
          type: "rect",
          x: 810 + yGap,
          y: 5,
          w: 300,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarYear = {
      canvas: [
        {
          type: "rect",
          x: 60,
          y: 5,
          w: 150,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarColor = {
      canvas: [
        {
          type: "rect",
          x: 275,
          y: 5,
          w: 180,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasPeriod1 = {
      canvas: [
        {
          type: "rect",
          x: 548,
          y: 5,
          w: 242,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasPeriod2 = {
      canvas: [
        {
          type: "rect",
          x: 867 + yGap,
          y: 5,
          w: 242,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarNumber = {
      canvas: [
        {
          type: "rect",
          x: 110,
          y: 5,
          w: 450,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarNumEn = {
      canvas: [
        {
          type: "rect",
          x: 753,
          y: 5,
          w: 383,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarBrandEngine = {
      canvas: [
        {
          type: "rect",
          x: 170,
          y: 5,
          w: 390,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasTypeEngine = {
      canvas: [
        {
          type: "rect",
          x: 753,
          y: 5,
          w: 383,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasDateRegis = {
      canvas: [
        {
          type: "rect",
          x: 170,
          y: 5,
          w: 390,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasLicensePlate = {
      canvas: [
        {
          type: "rect",
          x: 753,
          y: 5,
          w: 383,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarMiles = {
      canvas: [
        {
          type: "rect",
          x: 200,
          y: 5,
          w: 200,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasSizeAndweight = {
      canvas: [
        {
          type: "rect",
          x: 687 - 95,
          y: 5,
          w: 550,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasOrderCarOwner = {
      canvas: [
        {
          type: "rect",
          x: 200,
          y: 5,
          w: 150,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarOwner = {
      canvas: [
        {
          type: "rect",
          x: 500,
          y: 5,
          w: 637,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCarManual = {
      canvas: [
        {
          type: "rect",
          x: 350,
          y: 5,
          w: 787,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCharge = {
      canvas: [
        {
          type: "rect",
          x: 475,
          y: 5,
          w: 662,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasSufferers = {
      canvas: [
        {
          type: "rect",
          x: 250,
          y: 5,
          w: 886,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCompany = {
      canvas: [
        {
          type: "rect",
          x: 250,
          y: 5,
          w: 860,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };
    let canvasCompanyAddress = {
      canvas: [
        {
          type: "rect",
          x: 250,
          y: 5,
          w: 860,
          h: 35,
          r: 3,
          color: "lightgray",
          fillOpacity: 0.55,
        },
      ],
    };

    let lineHeader = {
      canvas: [
        {
          type: "line",
          x1: 438, // จุดเริ่ม X
          y1: 22, // จุดเริ่ม Y
          x2: 705, // จุดสิ้นสุด X
          y2: 22, // จุดสิ้นสุด Y (แนวนอนต้องเท่ากัน)
          lineWidth: 3,
          lineColor: "black", // หรือใช้ '#ADD8E6'
          //dash: { length: 8 }
        },
      ],
      absolutePosition: { x: 30, y: 60 },
    };
    let line = {
      canvas: [
        {
          type: "line",
          x1: 0, // จุดเริ่ม X
          y1: 143, // จุดเริ่ม Y
          x2: 1140, // จุดสิ้นสุด X
          y2: 143, // จุดสิ้นสุด Y (แนวนอนต้องเท่ากัน)
          lineWidth: 3,
          lineColor: "lightblue", // หรือใช้ '#ADD8E6'
          //dash: { length: 8 }
        },
      ],
      absolutePosition: { x: 30, y: 143 },
    };
    let line2 = {
      canvas: [
        {
          type: "line",
          x1: 0, // จุดเริ่ม X
          y1: 397, // จุดเริ่ม Y
          x2: 1140, // จุดสิ้นสุด X
          y2: 397, // จุดสิ้นสุด Y (แนวนอนต้องเท่ากัน)
          lineWidth: 3,
          lineColor: "lightblue", // หรือใช้ '#ADD8E6'
        },
      ],
      absolutePosition: { x: 30, y: 285 },
    };
    let lineVL = {
      canvas: [
        {
          type: "line",
          x1: 15,
          y1: 340,
          x2: 15,
          y2: 455,
          lineWidth: 3,
          lineColor: "lightblue",
        },
      ],
      absolutePosition: { x: 15, y: 340 },
    };
    let lineVR = {
      canvas: [
        {
          type: "line",
          x1: 600,
          y1: 340,
          x2: 600,
          y2: 455,
          lineWidth: 3,
          lineColor: "lightblue",
        },
      ],
      absolutePosition: { x: 570, y: 340 },
    };
    let lineBottom = {
      canvas: [
        {
          type: "line",
          x1: 0, // จุดเริ่ม X
          y1: 397, // จุดเริ่ม Y
          x2: 1140, // จุดสิ้นสุด X
          y2: 397, // จุดสิ้นสุด Y (แนวนอนต้องเท่ากัน)
          lineWidth: 3,
          lineColor: "lightblue", // หรือใช้ '#ADD8E6'
        },
      ],
      absolutePosition: { x: 30, y: 397 },
    };

    let OcpbBG =
      "data:image/png;base64,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";

    // ตำแหน่งเริ่มต้นข้อความ คอลัม 2 5 ตัว
    let startCol2 = 580;
    let docDefinition = {
      pageOrientation: "landscape",
      pageSize: "A3",
      pageMargins: [30, 20, 20, 0],
      background: { image: "tab", width: 1190 },
      content: [
        //canvasTopLeft,
        tableHeader,
        lineHeader,
        {
          columns: [
            canvasCarName,
            {
              width: "12%",
              text: "ยี่ห้อรถ",
              style: "body",
              absolutePosition: { x: 30, y: 110 + yGap },
            }, //84
            {
              width: "53%",
              style: "bodydetail",
              text: car_name_thai,
              absolutePosition: { x: 150, y: 99 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 110 + yGap },
        },

        {
          columns: [
            canvasCarPrice,
            {
              width: "9%",
              text: "ราคา",
              style: "body",
              absolutePosition: { x: 775 + yGap, y: 110 + yGap },
            },
            {
              width: "26%",
              style: "bodydetail",
              text: car_sale_price.toLocaleString() + " บาท",
              absolutePosition: { x: 865 + yGap, y: 99 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 110 + yGap },
        },

        {
          columns: [
            canvasCarTypeName,
            {
              width: "12%",
              text: "ประเภทรถ",
              style: "body",
              absolutePosition: { x: 30, y: 158 + yGap },
            },
            {
              width: "53%",
              style: "bodydetail",
              text: car_type_name,
              absolutePosition: { x: 160, y: 147 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 160 + yGap },
        },
        {
          columns: [
            canvasCarDown,
            {
              width: "9%",
              text: "ดาวน์",
              style: "body",
              absolutePosition: { x: 775 + yGap, y: 158 + yGap },
            },
            {
              width: "26%",
              style: "bodydetail",
              text: sum_down + " บาท",
              absolutePosition: { x: 865 + yGap, y: 147 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 159 + yGap },
        },
        {
          columns: [
            canvasCarYear,
            {
              width: "16%",
              text: "รุ่นปี",
              style: "body",
              absolutePosition: { x: 30, y: 206 + yGap },
            },
            {
              width: "21%",
              style: "bodydetail",
              text: car_year_name,
              absolutePosition: { x: 105, y: 195 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 206 + yGap },
        },
        {
          columns: [
            canvasCarColor,
            {
              width: "7%",
              text: "สี",
              style: "body",
              absolutePosition: { x: 265, y: 206 + yGap },
            },
            {
              width: "20%",
              style: "bodydetail",
              text: car_color_name,
              absolutePosition: { x: 320, y: 194 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 206 + yGap },
        },
        {
          columns: [
            canvasPeriod1,
            {
              width: "7%",
              text: "ผ่อน",
              style: "body",
              absolutePosition: { x: 515, y: 206 + yGap },
            },
            {
              width: "26%",
              style: "bodydetail",
              text: total_cost_period_call_72,
              absolutePosition: { x: 595, y: 195 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 206 + yGap },
        },
        {
          columns: [
            canvasPeriod2,
            {
              width: "7%",
              text: "ผ่อน",
              style: "body",
              absolutePosition: { x: 830 + yGap, y: 206 + yGap },
            },
            {
              width: "26%",
              style: "bodydetail",
              text: total_cost_period_call,
              absolutePosition: { x: 914 + yGap, y: 195 + yGap },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 206 + yGap },
        },
        // line,
        {
          columns: [
            canvasCarNumber,
            {
              width: "10%",
              text: "เลขตัวรถ",
              style: "body",
              absolutePosition: { x: 30, y: 254 + yGap2 },
            },
            {
              width: "43%",
              style: "bodydetail",
              text: car_number,
              absolutePosition: { x: 160, y: 243 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 254 + yGap2 },
        },
        {
          columns: [
            canvasCarNumEn,
            {
              width: "12%",
              text: "เลขเครื่องยนต์",
              style: "body",
              absolutePosition: { x: 618, y: 254 + yGap2 },
            },
            {
              width: "35%",
              style: "bodydetail",
              text: car_num_engines,
              absolutePosition: { x: 798, y: 243 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 254 + yGap2 },
        },
        {
          columns: [
            canvasCarBrandEngine,
            {
              width: "18%",
              text: "ยี่ห้อเครื่องยนต์",
              style: "body",
              absolutePosition: { x: 30, y: 302 + yGap2 },
            },
            {
              width: "35%",
              style: "bodydetail",
              text: car_brand_engine,
              absolutePosition: { x: 220, y: 291 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 302 + yGap2 },
        },
        {
          columns: [
            canvasTypeEngine,
            {
              width: "12%",
              text: "ชนิดเชื้อเพลิง",
              style: "body",
              absolutePosition: { x: 618, y: 302 + yGap2 },
            },
            {
              width: "35%",
              style: "bodydetail",
              text: car_type_engine_name,
              absolutePosition: { x: 798, y: 291 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 302 + yGap2 },
        },
        {
          columns: [
            canvasDateRegis,
            {
              width: "15%",
              text: "วันที่จดทะเบียน",
              style: "body",
              absolutePosition: { x: 30, y: 350 + yGap2 },
            },
            {
              width: "34%",
              style: "bodydetail",
              text: car_date_regis_thai,
              absolutePosition: { x: 220, y: 339 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 350 + yGap2 },
        },
        {
          columns: [
            canvasLicensePlate,
            {
              width: "8%",
              text: "เลขทะเบียน",
              style: "body",
              absolutePosition: { x: 618, y: 350 + yGap2 },
            },
            {
              width: "43%",
              style: "bodydetail",
              text: car_license_plate,
              absolutePosition: { x: 798, y: 339 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 350 + yGap2 },
        },
        {
          columns: [
            canvasCarMiles,
            {
              width: "20%",
              text: "ระยะทางการใช้งาน",
              style: "body",
              absolutePosition: { x: 30, y: 398 + yGap2 },
            },
            {
              width: "31%",
              style: "bodydetail",
              text: car_miles,
              absolutePosition: { x: 260, y: 387 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 398 + yGap2 },
        },
        {
          columns: [
            canvasSizeAndweight,
            {
              width: "16%",
              text: "ขนาด/น้ำหนัก",
              style: "body",
              absolutePosition: { x: 460, y: 398 + yGap2 },
            },
            {
              width: "*",
              style: "bodydetail",
              text: car_size_engine + car_weight,
              absolutePosition: { x: 729 - 95, y: 387 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 398 + yGap2 },
        },
        {
          columns: [
            canvasOrderCarOwner,
            {
              width: "20%",
              text: "เจ้าของรถลำดับที่",
              style: "body",
              absolutePosition: { x: 30, y: 446 + yGap2 },
            },
            {
              width: "21%",
              style: "bodydetail",
              text: order_car_owner,
              absolutePosition: { x: 260, y: 435 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 446 + yGap2 },
        },
        {
          columns: [
            canvasCarOwner,
            {
              width: "8%",
              text: "ชื่อ-สกุล",
              style: "body",
              absolutePosition: { x: 420, y: 446 + yGap2 },
            },
            {
              width: "50%",
              style: "bodydetail",
              text: car_owner,
              absolutePosition: { x: 550, y: 435 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 446 + yGap2 },
        },
        {
          columns: [
            canvasCarManual,
            {
              width: "33%",
              text: "สมุดคู่มือการบำรุงรักษารถ (ถ้ามี)",
              style: "body",
              absolutePosition: { x: 30, y: 494 + yGap2 },
            },
            {
              width: "68%",
              style: "bodydetail",
              text: car_manual,
              absolutePosition: { x: 410, y: 483 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 494 + yGap2 },
        },
        {
          columns: [
            canvasCharge,
            {
              width: "45%",
              text: "ภาระผูกพันของรถยนต์ที่มีในวันจำหน่าย (ถ้ามี)",
              style: "body",
              absolutePosition: { x: 30, y: 542 + yGap2 },
            },
            {
              width: "55%",
              style: "bodydetail",
              text: charge,
              absolutePosition: { x: 530, y: 531 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 542 + yGap2 },
        },
        {
          columns: [
            canvasSufferers,
            {
              width: "25%",
              text: "ข้อมูลประสบภัย (ถ้ามี)",
              style: "body",
              absolutePosition: { x: 30, y: 590 + yGap2 },
            },
            {
              width: "75%",
              style: "bodydetail",
              text: sufferers,
              absolutePosition: { x: 300, y: 579 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 590 + yGap2 },
        },
        //line2,
        //lineVL,
        //lineVR,
        // lineBottom,
        {
          columns: [
            canvasCompany,
            {
              width: "25%",
              text: "ผู้ประกอบธุรกิจ",
              style: "bodycompany",
              absolutePosition: { x: 45, y: 652 + yGap2 },
            },
            {
              width: "75%",
              style: "bodycompanydetail",
              text: company_name,
              absolutePosition: { x: 300, y: 652 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 652 + yGap2 },
        },
        {
          columns: [
            canvasCompanyAddress,
            {
              width: "25%",
              text: "สถานที่ประกอบการ",
              style: "bodycompany",
              absolutePosition: { x: 45, y: 700 + yGap2 },
            },
            {
              width: "75%",
              style: "bodycompany",
              text: company_address,
              absolutePosition: { x: 300, y: 701 + yGap2 },
            },
          ],
          columnGap: 10,
          lineHeight: 1,
          absolutePosition: { x: 30, y: 700 + yGap2 },
        },
      ],

      images: {
        tab: OcpbBG,
      },
      styles: {
        header: {
          fontSize: 48,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 36,
          bold: true,
        },
        bodydetail: {
          fontSize: 56,
          bold: true,
        },
        bodydetailcenter: {
          fontSize: 56,
          bold: true,
          alignment: "center",
        },
        bodycompany: {
          fontSize: 36,
          bold: true,
        },
        bodycompanydetail: {
          fontSize: 40,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };

    pdfMake.createPdf(docDefinition).open();
  }

  onDeleteCarOwner(carOwner) {
    const car_owner_id = carOwner.car_owner_id;
    const car_license = carOwner.car_license;
    const owner_name = carOwner.owner_name;

    Swal.fire({
      title: "ยืนยันการลบ " + owner_name + " ทะเบียน: " + car_license,
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        let url = APIURL + "/car_owner/" + car_owner_id;
        axios
          .delete(url)
          .then((res) => {
            if (res.status === 200) {
              AlertSuccess("ลบข้อมูลเรียบร้อยแล้ว");
              this.loadCarOwnerData();
            }
          })
          .catch((error) => {
            console.log("error:", error);
          });
      }
    });
  }

  convertLicenseIdToName(liciense_status_id) {
    // let liciense_status_name = CarUtil.convertLicenseIdToName(liciense_status_id)
    getLicienseStatuses().then((res) => {
      let liciense_status = res.data;
      let liciense_status_name = liciense_status.filter(
        (status) => status.liciense_status_id === liciense_status_id
      )[0].liciense_status_name;
      this.setState({
        liciense_status_name: liciense_status_name,
      });
    });
  }

  render() {
    let {
      vat_sell,
      finance_commission,
      car_external_commission,
      sales_commission,
      additional_commission,
      advertising_cost,
      delivery_fee,
      promotion_fee,
      finance_fee,
      transfer_fee,
      vat_commission,
      cost_after_sales_service,
      tax_invoice_vat,
      tax_commission_amount,
      tax_commission_vat,
      form_controls,
      amount_of_debt,
    } = this.state;

    let width = this.state.width;

    let car = this.state.car;
    let car_sell = this.state.car_sell;
    let car_doc_list = this.state.car_doc_list;
    let car_expense_list = this.state.car_expense_list;

    let finance_name =
      typeof car === "object"
        ? this.state.banks.filter((bank) => {
            return bank.bank_id === car.finance_id;
          })
        : "-";

    let finance_floorplan_name =
      typeof car === "object"
        ? this.state.banks.filter((bank) => {
            return bank.bank_id === car.finance_floorplan_id;
          })
        : "-";

    let insurance_type_name = this.state.insurance_types.filter(
      (insurance_type) => {
        return insurance_type.insurance_type_id === car.insurance_type_id;
      }
    );

    let insurance_company_name = this.state.insurance_companies.filter(
      (insurance_company) => {
        return (
          insurance_company.insurance_company_id === car.insurance_company_id
        );
      }
    );

    let compulsory_insurance_company_name =
      this.state.insurance_companies.filter((insurance_company) => {
        return (
          insurance_company.insurance_company_id ===
          car.compulsory_insurance_company
        );
      });

    let is_cal_vat = true;
    let real_sell_price = 0;
    let text_sum_cost = "รวมทุน(รวม VAT ซื้อ)";

    // PORT === 9008
    if (PORT === 9043) {
      is_cal_vat = false;
      text_sum_cost = "รวมทุน(ไม่รวม VAT ซื้อ)";
    }

    let vat_buy = is_cal_vat
      ? car.vat_buy === null
        ? 0
        : Number(car.vat_buy)
      : 0;
    let cost_car_in = getSumCostBeforeSell(car);
    let cost_after_car_sell = 0;
    let profit = 0.0;
    let sell_all = 0.0;
    let vat_tax_invoice = 0;
    let tax_commission = 0;
    let vat_tax_commission = 0;
    let cost_all = 0.0;

    // TODx: ค่าใช้จ่ายในการขาย(แท็บ)

    if (this.state.car_sell_id === 0 && Object.keys(car).length !== 0) {
      // ก่อนขาย
      real_sell_price = car.car_sale_price;
      sell_all = car.car_sale_price;
      cost_all = car.car_cost + cost_car_in + vat_buy;
      profit = real_sell_price - cost_all;
    } else if (this.state.car_sell_id !== 0 && Object.keys(car).length !== 0) {
      // หลังขาย
      real_sell_price = this.state.car_sell.real_sell_price;

      vat_tax_invoice =
        this.state.vat_sell === 0
          ? this.state.tax_invoice_vat === null
            ? 0
            : this.state.tax_invoice_vat
          : this.state.vat_sell;
      tax_commission =
        this.state.finance_commission === 0
          ? this.state.tax_commission_amount
          : this.state.finance_commission;
      vat_tax_commission =
        this.state.vat_commission === 0
          ? this.state.tax_commission_vat
          : this.state.vat_commission;

      if (is_cal_vat === false) {
        vat_tax_invoice = 0;
        vat_tax_commission = 0;
      }

      let income_car_sell =
        Number(vat_tax_invoice) +
        Number(tax_commission) +
        Number(vat_tax_commission);
      cost_after_car_sell = getSumCostAfterSell(car_sell);

      cost_all = car.car_cost + cost_car_in + cost_after_car_sell + vat_buy;
      sell_all =
        real_sell_price +
        Number(vat_tax_invoice) +
        Number(tax_commission) +
        Number(vat_tax_commission);

      let profit_car_sell = income_car_sell - cost_after_car_sell;
      profit = real_sell_price - cost_all + profit_car_sell;

      if (port !== 9048) {
        // - ตั้งหนี้ค้างดาวน์
        profit = profit - amount_of_debt;
      }
    }

    // let car_sell_price = this.state.car_sell_id === 0 ? car.car_sale_price : this.state.car_sell.real_sell_price

    // ทุนซื้อเข้า car_cost_other, car_cost_expenses_other, car_cost_commissions, car_cost_act, car_cost_tax

    // let car_cost_other_sum = Number(car.car_cost_other) + Number(car.car_cost_expenses_other) + Number(car.car_cost_commissions) +
    // Number(car.car_cost_act) + Number(car.car_cost_tax)
    //   // ทุนซื้อเข้า 2 at
    // let car_cost_other_sum2 = 0;
    // car_cost_other_sum2 += Number(car.cost_operation);
    // car_cost_other_sum2 += Number(car.cost_service);
    // car_cost_other_sum2 += Number(car.cost_transport);
    // car_cost_other_sum2 += Number(car.cost_porobor_lan);
    // car_cost_other_sum2 += Number(car.cost_bangkhab_phasi_lan);
    // car_cost_other_sum2 += Number(car.cost_bangkhab_xon_lan);
    // car_cost_other_sum2 += Number(car.cost_check_ton);

    // let profit_before_sell = car_sell_price - (car.car_cost + car.car_cost_repair + car_cost_other_sum + car_cost_other_sum2 + vat_buy);

    //let profit = this.state.car_sell_id === 0 ? profit_before_sell : profit_before_sell + profit_after_sell - profit_after_sell2

    // ตอนขายไม่ถูก เพราะยังใช้ราคา car.car_sale_price
    // let profit = this.state.car_sell_id === 0 ? getProfitBeforeSell(car) : getProfitBeforeSell(car) + profit_after_total;

    // let profit = 0
    // if (this.state.car_sell_id === 0) {
    //     profit = getProfitBeforeSell(car)
    // } else {
    //     // ตอนขายต้องใช้ราคาขายจริง
    //     profit = car_sell_price - ()
    // }

    // if (port !== 9048) {
    //     // - ตั้งหนี้ค้างดาวน์
    //     profit = profit - amount_of_debt;
    // }

    // 9043 รวมทุนไม่รวมภาษีซื้อ ภาษีซื้อไม่นับเป็นค่าใช้จ่าย แต่เป็นสินทรัพย์ภาษีมูลค่าเพิ่มที่นำไปหักจากภาษีขาย 26-2-68
    /*let cost_all = (car.car_cost + car.car_cost_repair  + car_cost_other_sum + car_cost_other_sum2 + vat_buy) + (Number(car_external_commission) +
    Number(sales_commission) + Number(additional_commission) + Number(advertising_cost) + Number(delivery_fee) + Number(promotion_fee)) +
    Number(finance_fee) + Number(transfer_fee) + Number(cost_after_sales_service)*/

    // let cost_after_sell = Number(car_external_commission) +
    // Number(sales_commission) + Number(additional_commission) + Number(advertising_cost) + Number(delivery_fee) + Number(promotion_fee) +
    // Number(finance_fee) + Number(transfer_fee) + Number(cost_after_sales_service)

    // let cost_all = car.car_cost + cost_car_in + cost_after_car_sell + vat_buy ;
    // let sell_all = car_sell_price + Number(vat_tax_invoice) + Number(tax_commission) + Number(vat_tax_commission)

    // if(PORT === 9043 || PORT === 9008){
    //     // ไม่รวม vat_buy
    //     cost_all = car.car_cost + cost_car_in + cost_after_sell;
    // }

    // if(PORT === 9043 || PORT === 9008){
    //     // no vat and commission
    //     sell_all = car_sell_price
    //     profit = sell_all - cost_all
    // }

    // if(PORT === 9043 || PORT === 9008){
    //
    // }

    let car_date_in = DateUtil.convertLongDateThai(car.car_date_in);
    let warantee_date_end = DateUtil.convertLongDateThai(car.warantee_date_end);
    let car_date_regis = DateUtil.convertLongDateThai(car.car_date_regis);
    let car_date_tax = DateUtil.convertLongDateThai(car.car_date_tax);
    let insurance_end_date = DateUtil.convertLongDateThai(
      car.insurance_end_date
    );
    let floorplan_start_date = DateUtil.convertLongDateThai(
      car.floorplan_start_date
    );
    let floorplan_due_date = DateUtil.convertLongDateThai(
      car.floorplan_due_date
    );
    let receipt_date = DateUtil.convertLongDateThai(car.receipt_date);

    return (
      <div className="col-md-12 mb-4">
        <Loading isLoading={this.state.isLoading} />
        <Nav tabs>
          {checkGroupPermission(18, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "1" })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                <i className="icon-options-vertical" /> ข้อมูลทั่วไป
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(19, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "2" })}
                onClick={() => {
                  this.toggle("2");
                }}
              >
                <i className="icon-badge" /> อุปกรณ์เสริมอื่นๆ
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(20, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "3" })}
                onClick={() => {
                  this.toggle("3");
                }}
              >
                <i className="icon-user" /> ข้อมูลเจ้าของรถ
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(21, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "4" })}
                onClick={() => {
                  this.toggle("4");
                }}
              >
                <i className="icon-picture" /> อัลบั้มรูป
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(22, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "5" })}
                onClick={() => {
                  this.toggle("5");
                }}
              >
                <i className="icon-doc" /> เอกสารรถ
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(27, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "8" })}
                onClick={() => {
                  this.toggle("8");
                }}
              >
                <i className="icon-shield" /> เอกสารลับ
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(29, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "10",
                })}
                onClick={() => {
                  this.toggle("10");
                }}
              >
                <i className="icon-paper-clip" /> เอกสารขาย
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(23, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "6" })}
                onClick={() => {
                  this.toggle("6");
                }}
              >
                <i className="icon-wrench" /> ค่าซ่อมบำรุง
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(28, this.state.grouppermissions).viewed &&
          port === 9008 ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "9" })}
                onClick={() => {
                  this.toggle("9");
                }}
              >
                <i className="icon-wrench" /> ค่าซ่อม(หลังขาย)
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(28, this.state.grouppermissions).viewed &&
          this.state.car_sell_id !== 0 &&
          port !== 9008 ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "9" })}
                onClick={() => {
                  this.toggle("9");
                }}
              >
                <i className="icon-wrench" /> ค่าซ่อม(หลังขาย)
              </NavLink>
            </NavItem>
          ) : null}

          {/*{
                        checkGroupPermission(25, this.state.grouppermissions).viewed === false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.activeTab === '9' })}
                              onClick={() => { this.toggle('9'); }}
                            >
                              <i className="icon-wallet"/> รายการซ่อมเคลม(หลังขาย)
                            </NavLink>
                          </NavItem>
                        ) : null
                      }*/}

          {checkGroupPermission(36, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "11",
                })}
                onClick={() => {
                  this.toggle("11");
                }}
              >
                <i className="icon-wallet" /> ค่าใช้จ่ายในการขาย(ของรถ)
              </NavLink>
            </NavItem>
          ) : null}

          {checkGroupPermission(24, this.state.grouppermissions).viewed ? (
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "7" })}
                onClick={() => {
                  this.toggle("7");
                }}
              >
                <i className="icon-wallet" /> ค่าใช้จ่ายอื่นๆ ของรถ
              </NavLink>
            </NavItem>
          ) : null}

          {/*{
                        port === '9021' && this.state.user.type === 'sale' ? null : (
                          this.state.user.type === 'admin' ||  this.state.user.type === "manager" ||  this.state.user.type === "account" || this.state.user.type === "sale" ? null
                             : null
                        )
                      }*/}

          {}
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      ข้อมูลทั่วไป &nbsp;
                      {car === null ? null : (
                        <>
                          (ทะเบียน: {car.car_license_plate_new} /{" "}
                          {car.car_license_plate_old})
                        </>
                      )}
                    </strong>
                    {/*{
                                        port === '9021' && this.state.user.type === 'sale' ? null : null

                                        checkGroupPermission(24, this.state.grouppermissions).viewed
                                        checkGroupPermission(23, this.state.grouppermissions).created
                                        checkGroupPermission(24, this.state.grouppermissions).modified
                                        checkGroupPermission(24, this.state.grouppermissions).deleted
                                      }*/}

                    {checkGroupPermission(18, this.state.grouppermissions)
                      .viewloged ? (
                      <>
                        <Button
                          type="button"
                          className="btn btn-secondary float-right"
                          onClick={() => {
                            this.setState({
                              toggle_data_log_car_edit: true,
                            });
                          }}
                        >
                          <i className="icon-arrow-down" />
                        </Button>
                      </>
                    ) : null}

                    {checkGroupPermission(18, this.state.grouppermissions)
                      .modified ? (
                      <Button
                        type="button"
                        onClick={this.toggleCarEdit}
                        className="btn btn-warning float-right mr-2"
                      >
                        <i className="icon-note" />
                        &nbsp;&nbsp;แก้ไขข้อมูลรถ
                      </Button>
                    ) : null}

                    {checkGroupPermission(18, this.state.grouppermissions)
                      .printed ? (
                      <Button
                        type="button"
                        onClick={this.toggleSorkorbor}
                        className="btn btn-info float-right mr-2"
                      >
                        <i className="icon-printer" />
                        &nbsp;&nbsp;พิมพ์ใบ สคบ.
                      </Button>
                    ) : null}

                    {/*{
                                        checkGroupPermission(18, this.state.grouppermissions).printed && port === 9043 ? (
                                          <Button type="button" onClick={this.toggleSorkorbor} className="btn btn-info float-right mr-2">
                                            <i className="icon-printer"/>&nbsp;&nbsp;พิมพ์ใบ สคบ.
                                          </Button>
                                        ) :null
                                      }*/}

                    <Modal
                      isOpen={this.state.primary}
                      toggle={this.toggleCarEdit}
                      className={"modal-lg " + this.props.className}
                      style={
                        width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }
                      }
                    >
                      <ModalBody>
                        {this.state.primary === true && (
                          <CarEditGeneral
                            onToggle={this.toggleCarEdit}
                            isOpen={this.state.primary}
                            onLoadCarById={() => {
                              this.loadCarById();
                            }}
                            isDateFill={this.state.is_date_fill}
                            car={this.state.car}
                            car_sell_id={this.state.car_sell_id}
                            form_controls={this.state.form_controls}
                          />
                        )}
                      </ModalBody>
                    </Modal>

                    {this.state.toggle_data_log_car_edit && (
                      <DataLog
                        is_open={this.state.toggle_data_log_car_edit}
                        table_name={"car"}
                        ref_id={this.state.car_id}
                        menu_id={18}
                        title={"แก้ไขข้อมูลรถ"}
                        onToggle={() => {
                          this.setState({
                            toggle_data_log_car_edit:
                              !this.state.toggle_data_log_car_edit,
                          });
                        }}
                        onClose={() => {
                          this.setState({
                            toggle_data_log_car_edit: false,
                          });
                        }}
                      />
                    )}

                    {this.state.toggle_data_log_car_price && (
                      <DataLog
                        is_open={this.state.toggle_data_log_car_price}
                        table_name={"car"}
                        ref_id={this.state.car_id}
                        menu_id={106}
                        title={"ราคา/ค่าใช้จ่าย (ซื้อเข้า)"}
                        onToggle={() => {
                          this.setState({
                            toggle_data_log_car_price:
                              !this.state.toggle_data_log_car_price,
                          });
                        }}
                        onClose={() => {
                          this.setState({
                            toggle_data_log_car_price: false,
                          });
                        }}
                      />
                    )}

                    <Modal
                      className="modal-sm modal-dialog"
                      isOpen={this.state.toggle_bill_print}
                      toggle={this.toggleSorkorbor}
                      style={
                        width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }
                      }
                    >
                      <ModalBody>
                        <div id="divToPrint">
                          <div className="row">
                            <div className="col-md-12 text-center mt-4">
                              <strong>เพิ่มข้อมูลฉลากรถยนต์ใช้แล้ว</strong>
                            </div>

                            <div className="col-md-12 text-center mt-4">
                              <strong>
                                ยี่ห้อ / รุ่นรถ : {this.state.car.car_name}
                              </strong>
                            </div>
                          </div>

                          <div className="row p-5">
                            <div className="form-group col-sm-5">
                              <strong>ยี่ห้อ / รุ่นรถภาษาไทย :</strong>
                              <br />
                              <span>
                                (หากต้องการแสดงยี่ห้อ / รุ่นรถเป็นภาษาไทย)
                              </span>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="กรอกข้อมูลยี่ห้อ / รุ่นรถภาษาไทย"
                                ref="car_name_thai"
                                value={this.state.car_name_thai || ""}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  this.setState({
                                    car_name_thai: val,
                                  });
                                }}
                              />
                            </div>

                            <div className="form-group col-sm-5">
                              <strong>ราคาขาย(เปลี่ยนแปลงได้):</strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="car_sale_price_sorkorbor"
                                value={this.state.car_sale_price_sorkorbor}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  this.setState({
                                    car_sale_price_sorkorbor: val,
                                  });
                                }}
                              />
                            </div>

                            <div className="form-group col-sm-5">
                              <strong>ดาวน์ :</strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="sum_down"
                                name="sum_down"
                                value={this.state.sum_down}
                                onChange={this.handleOnChange}
                              />
                            </div>

                            {PORT === 9024 ? (
                              <>
                                <div className="form-group col-sm-5">
                                  <strong>ผ่อน 72 งวด:</strong>
                                </div>
                                <div className="form-group col-sm-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    ref="total_cost_period_call_72"
                                    placeholder="ex. 9800 x 72"
                                    name="total_cost_period_call_72"
                                    value={this.state.total_cost_period_call_72}
                                    onChange={this.handleOnChange}
                                  />
                                </div>
                              </>
                            ) : null}

                            <div className="form-group col-sm-5">
                              <strong>
                                {PORT === 9024 ? "ผ่อน 84 งวด:" : "ผ่อน :"}
                              </strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="total_cost_period_call"
                                placeholder="ex. 7800 x 84"
                                name="total_cost_period_call"
                                value={this.state.total_cost_period_call}
                                onChange={this.handleOnChange}
                              />
                            </div>

                            <div className="form-group col-sm-5">
                              <strong>เจ้าของรถลำดับที่ :</strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="order_car_owner"
                                name="order_car_owner"
                                value={this.state.order_car_owner}
                                onChange={this.handleOnChange}
                              />
                            </div>

                            <div className="form-group col-sm-5">
                              <strong>
                                สมุดคู่มือการบำรุงรักษารถ (ถ้ามี) :
                              </strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="car_manual"
                                value={this.state.car_manual}
                                onChange={(e) => {
                                  this.setState({
                                    car_manual: e.target.value,
                                  });
                                }}
                              />
                            </div>

                            <div className="form-group col-sm-5">
                              <strong>
                                ภาระผูกพันของรถยนต์ที่มีอยู่ในวันที่จำหน่าย
                                (ถ้ามี)
                              </strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="charge"
                                value={this.state.charge}
                                onChange={(e) => {
                                  this.setState({
                                    charge: e.target.value,
                                  });
                                }}
                              />
                            </div>

                            <div className="form-group col-sm-5">
                              <strong>ข้อมูลการประสบภัย (ถ้ามี) :</strong>
                            </div>
                            <div className="form-group col-sm-6">
                              <input
                                type="text"
                                className="form-control"
                                ref="sufferers"
                                value={this.state.sufferers}
                                onChange={(e) => {
                                  this.setState({
                                    sufferers: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          color="primary"
                          onClick={() => {
                            if (port === 9043) {
                              this.printOcpbAtCarSale();
                            } else if (port === 9059) {
                              this.printOcpbCarOk();
                            } else if (port === 9021) {
                              // this.printOcpb()
                              this.printOcpbA3();
                            } else if (port === 9024) {
                              this.printOcpbSamkor();
                            } else {
                              this.printOcpbA3();
                            }
                          }}
                        >
                          พิมพ์
                        </Button>{" "}
                        <Button
                          color="secondary"
                          onClick={this.toggleSorkorbor}
                        >
                          ยกเลิก
                        </Button>
                      </ModalFooter>
                    </Modal>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">
                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> สาขาที่รถอยู่ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.branch_name} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> วันที่ซื้อรถเข้ามา </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car_date_in} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ซื้อรถจาก </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {car.buy_car_from === "" ||
                                car.buy_car_from === null
                                  ? "-"
                                  : car.buy_car_from}{" "}
                              </strong>
                            </span>
                          </div>
                          <label className="col-md-3 ">
                            <strong> รถจอด </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.park_location} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> เกรดรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {car.car_grade === "" || car.car_grade === null
                                  ? "-"
                                  : car.car_grade}{" "}
                              </strong>
                            </span>
                          </div>
                          <label className="col-md-3 ">
                            <strong> วันที่ warantee สิ้นสุด </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>{warantee_date_end}</strong>
                            </span>
                          </div>
                        </div>

                        {port === 9038 || port === 9039 ? (
                          <div
                            className=" form-group row"
                            style={styles.bottomLine}
                          >
                            <label className="col-md-3 ">
                              <strong> รหัสสินค้า / รหัสรถ </strong>
                            </label>
                            <div className="col-md-3 ">
                              <span className="text-justify text-primary">
                                <strong> {car.code_item} </strong>
                              </span>
                            </div>
                          </div>
                        ) : null}

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ชื่อรถ </strong>
                          </label>
                          <div className="col-md-9">
                            <span className="text-justify text-primary">
                              <strong> {car.car_name} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> รายละเอียดรถ </strong>
                          </label>
                          <div className="col-md-9">
                            <span className="text-justify text-primary">
                              <strong> {car.car_detail} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> สถานะ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_status_name} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> วันที่จดทะเบียน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>{car_date_regis}</strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ยี่ห้อ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_brand_name} </strong>
                            </span>
                          </div>

                          <label className="col-md-3 ">
                            <strong> รุ่นรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_model_name} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> รุ่นย่อย </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_sub_model_name} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> สีรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_color_name} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ระบบเกียร์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_gear_name} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> ปีรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_year_name} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> เบาะรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_hassock_name} </strong>
                            </span>
                          </div>
                        </div>

                        {/*<div className=" form-group row" style={styles.bottomLine}>
                                                    <label className="col-md-3"><strong> เลขไมล์ </strong></label>
                                                    <div className="col-md-3">
                                                        <span className="text-justify text-primary"><strong> {car.car_miles} </strong></span>
                                                    </div>
                                                </div>*/}

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> เลขตัวรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span
                              className="text-justify text-primary"
                              style={styles.toUpper}
                            >
                              <strong> {car.car_number} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> เลขเครื่องยนต์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span
                              className="text-justify text-primary"
                              style={styles.toUpper}
                            >
                              <strong> {car.car_num_engines} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ประเภท </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_type_name} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> ลักษณะ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_structure_name} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "car_system_drive_id"
                                )[0].visibility === 0 &&
                                this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "car_type_engine_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_system_drive_id"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <strong> ระบบขับเคลื่อน </strong>
                          </label>
                          <div
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_system_drive_id"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong> {car.car_system_drive_name} </strong>
                            </span>
                          </div>

                          <label
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_type_engine_id"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <strong> ประเภทเครื่องยนต์ </strong>
                          </label>
                          <div
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_type_engine_id"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong> {car.car_type_engine_name} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "car_brand_engine"
                                )[0].visibility === 0 &&
                                this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_gas_number"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_brand_engine"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <strong> ยี่ห้อเครื่องยนต์ </strong>
                          </label>
                          <div
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_brand_engine"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong> {car.car_brand_engine} </strong>
                            </span>
                          </div>

                          <label
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_gas_number"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <strong> เลขถังแก๊ส </strong>
                          </label>
                          <div
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_gas_number"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong> {car.car_gas_number} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_weight"
                                )[0].visibility === 0 &&
                                this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "car_size_engine"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name === "car_weight"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <strong> น้ำหนักรถ (กิโลกรัม) </strong>
                          </label>
                          <div
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name === "car_weight"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong> {car.car_weight} </strong>
                            </span>
                          </div>

                          <label
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_size_engine"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <strong> ขนาดเครื่องยนต์ (ซีซี) </strong>
                          </label>
                          <div
                            className={
                              this.state.form_controls.length > 0
                                ? this.state.form_controls.filter(
                                    (form_control) =>
                                      form_control.field_name ===
                                      "car_size_engine"
                                  )[0].visibility === 0
                                  ? "hidden"
                                  : "col-md-3"
                                : "hidden"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong> {car.car_size_engine} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ป้ายทะเบียนใหม่ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_license_plate_new} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> จังหวัด </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.province_name_new} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "termination_s79"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> แจ้งเลิกใช้รถ (ม.79) </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {CarUtil.convertTerminationS79(
                                  car.termination_s79
                                )}{" "}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> แจ้งไม่เสียภาษีรถ (ม.89) </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {CarUtil.convertNonPaymentS89(
                                  car.non_payment_s89
                                )}{" "}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> วันที่ครบกำหนดต่อภาษี </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car_date_tax} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> ราคาภาษีรถยนต์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_tax} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ประเภทประกันภัย </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {insurance_type_name.length === 1
                                  ? insurance_type_name[0].insurance_type_name
                                  : "-"}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> บ.ประกันภัย </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {insurance_company_name.length === 1
                                  ? insurance_company_name[0]
                                      .insurance_company_name
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> วันที่สิ้นสุดประกันรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {insurance_end_date} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> พรบ. </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.compulsory_insurance !== ""
                                  ? car.compulsory_insurance
                                  : "-"}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> บ.พรบ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {compulsory_insurance_company_name.length === 1
                                  ? compulsory_insurance_company_name[0]
                                      .insurance_company_name
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> วันที่สิ้นสุด พรบ. </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {car.compulsory_insurance_end_date !== null &&
                                car.compulsory_insurance_end_date !==
                                  "0000-00-00"
                                  ? moment(car.compulsory_insurance_end_date)
                                      .locale("th")
                                      .format("LL")
                                  : "-"}{" "}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> กุญแจสำรอง </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.car_spare_key !== ""
                                  ? car.car_spare_key
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> คู่มือรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.car_manual !== "" ? car.car_manual : "-"}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> คู่มือบริการ (Book Service)</strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.car_book_service !== ""
                                  ? car.car_book_service
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> สถานะเล่ม </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>{this.state.liciense_status_name}</strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> การเปลี่ยนเล่ม </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {this.state.car.change_book_status_name || "-"}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong>
                              {CarUtil.getLabelName(
                                this.state.form_controls,
                                "car_adapt_status_id",
                                "การดัดแปลง"
                              )}
                            </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {this.state.car.car_adapt_status_name || "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> มัดจำเล่มทะเบียน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {CarUtil.convertDepositRegistration(
                                  car.deposit_registration_id
                                )}{" "}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> ไฟแนนซ์รอเล่มทะเบียน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {finance_name.length === 1
                                  ? finance_name[0].bank_name
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> วันที่รับเล่ม </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {receipt_date} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "floorplan_credit"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ยอดเงินฟลอร์แพลน(จำนวนเงิน) </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.floorplan_credit > 0
                                  ? car.floorplan_credit.toLocaleString()
                                  : "-"}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> ไฟแนนซ์ฟลอร์แพลน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {finance_floorplan_name.length === 1
                                  ? finance_floorplan_name[0].bank_name
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "floorplan_start_date"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> วันเริ่มเล่มฟลอร์แพลน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {floorplan_start_date} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> วันครบกำหนดเล่มฟลอร์แพลน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {floorplan_due_date} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name ===
                                    "floorplan_annual_interest"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> % ดอกเบี้ยฟลอร์แพลนต่อเดือน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.floorplan_annual_interest > 0
                                  ? car.floorplan_annual_interest.toLocaleString()
                                  : "-"}{" "}
                                %
                                {/*<NumberFormat
                                                                    value={car.floorplan_annual_interest}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={' %'}
                                                                />*/}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ไมล์ศูนย์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {car.car_miles_center !== ""
                                  ? NumberUtil.addCommas(car.car_miles_center)
                                  : "-"}{" "}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> วันเช็คไมล์ศูนย์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.car_miles_center_date !== null &&
                                car.car_miles_center_date !== "0000-00-00"
                                  ? moment(car.car_miles_center_date)
                                      .locale("th")
                                      .format("LL")
                                  : "-"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.form_controls.length > 0
                              ? this.state.form_controls.filter(
                                  (form_control) =>
                                    form_control.field_name === "car_type_id"
                                )[0].visibility === 0
                                ? "hidden"
                                : "form-group row"
                              : "hidden"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> เลขไมล์ปัจจุบัน (ไมล์หน้ารถ) </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {car.car_miles !== ""
                                  ? NumberUtil.addCommasZeroInt(car.car_miles)
                                  : "-"}{" "}
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> สถานะไมล์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                <strong>
                                  {" "}
                                  {car.car_miles_status !== ""
                                    ? car.car_miles_status
                                    : "-"}{" "}
                                </strong>
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> หมายเหตุ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                {car.car_explain === ""
                                  ? "-"
                                  : car.car_explain}{" "}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> รายละเอียดออฟชั่น อื่นๆ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.car_feature_other === undefined ||
                                car.car_feature_other === null
                                  ? "-"
                                  : parse(car.car_feature_other)}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            WEBSITEURL === undefined
                              ? "hidden"
                              : " form-group row"
                          }
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ข้อความค่างวดแสดงที่เว็บ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.web_info === undefined ||
                                car.web_info === null
                                  ? "-"
                                  : car.web_info}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> แก้ไขล่าสุด </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {" "}
                                แก้ไขโดย: {car.user_updated} เมื่อ:{" "}
                                {moment(car.updated_at).format(
                                  "DD-MM-YYYY HH:mm:ss"
                                )}
                              </strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={
                checkGroupPermission(106, this.state.grouppermissions).modified
                  ? "row"
                  : "hidden"
              }
            >
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    {this.state.car_sell_id === 0 ? (
                      <strong className="text-title">
                        ราคา/ค่าใช้จ่าย (ซื้อเข้า){" "}
                      </strong>
                    ) : (
                      <strong>ราคา/ค่าใช้จ่าย(ขายแล้ว)</strong>
                    )}

                    {checkGroupPermission(106, this.state.grouppermissions)
                      .viewloged ? (
                      <>
                        <Button
                          type="button"
                          className="btn btn-secondary float-right "
                          onClick={() => {
                            this.setState({
                              toggle_data_log_car_price: true,
                            });
                          }}
                        >
                          <i className="icon-arrow-down" />
                        </Button>
                      </>
                    ) : null}

                    <Button
                      type="button"
                      onClick={this.toggleCarEditPrice}
                      className="btn btn-warning float-right mr-2"
                    >
                      <i className="icon-note" />
                      &nbsp;&nbsp;แก้ไขราคา
                    </Button>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">
                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          {this.state.car_sell_id === 0 ? (
                            <>
                              <label
                                className={
                                  port === 9029 &&
                                  this.state.user.type === "manager"
                                    ? "hidden"
                                    : "col-md-3"
                                }
                              >
                                <strong> ราคาขาย </strong>
                              </label>
                              <div
                                className={
                                  port === 9029 &&
                                  this.state.user.type === "manager"
                                    ? "hidden"
                                    : "col-md-3"
                                }
                              >
                                <span className="text-justify text-primary">
                                  <strong>
                                    <NumberFormat
                                      value={car.car_sale_price}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"฿"}
                                    />
                                  </strong>
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <label className="col-md-3">
                                <strong> ราคาขายจริง </strong>
                              </label>
                              <div className="col-md-3">
                                <span className="text-justify text-primary">
                                  <strong>
                                    <NumberFormat
                                      value={
                                        this.state.car_sell.real_sell_price
                                      }
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"฿"}
                                    />
                                  </strong>
                                </span>
                              </div>
                            </>
                          )}
                        </div>

                        <div
                          className={
                            PORT === 9034 && this.state.user.type !== "admin"
                              ? "hidden"
                              : " form-group row"
                          }
                          style={styles.bottomLine}
                        >
                          <label
                            className={
                              PORT === 9034 && this.state.user.type !== "admin"
                                ? "hidden"
                                : "col-md-3 "
                            }
                          >
                            <strong> ราคาซื้อ (ไม่รวมภาษี) </strong>
                          </label>
                          <div
                            className={
                              PORT === 9034 && this.state.user.type !== "admin"
                                ? "hidden"
                                : "col-md-3"
                            }
                          >
                            <span className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car.car_cost}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>

                              {car.vat_buy > 0 ? (
                                <>
                                  <br />
                                  รวม:{" "}
                                  <NumberFormat
                                    value={car.car_cost + car.vat_buy}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"฿"}
                                  />
                                </>
                              ) : null}
                            </span>
                          </div>

                          <label
                            className={
                              PORT === 9034 && this.state.user.type !== "admin"
                                ? "hidden"
                                : "col-md-3"
                            }
                          >
                            <strong> ภาษีซื้อ </strong>
                          </label>
                          <div
                            className={
                              PORT === 9034 && this.state.user.type !== "admin"
                                ? "hidden"
                                : "col-md-3"
                            }
                          >
                            <span className="text-justify text-primary">
                              <NumberFormat
                                value={car.vat_buy}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"฿"}
                              />
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ค่าซ่อมบำรุง </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car.car_cost_repair}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>

                          {form_controls.length > 0 ? (
                            form_controls.filter(
                              (form_control) =>
                                form_control.field_name === "car_cost_act"
                            )[0].visibility === 0 ? null : (
                              <>
                                <label className="col-md-3">
                                  <strong> ค่าใช้จ่าย พ.ร.บ. </strong>
                                </label>
                                <div className="col-md-3">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.car_cost_act}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>
                              </>
                            )
                          ) : null}
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          {form_controls.length > 0 ? (
                            form_controls.filter(
                              (form_control) =>
                                form_control.field_name === "car_cost_tax"
                            )[0].visibility === 0 ? null : (
                              <>
                                <label className="col-md-3 ">
                                  <strong> ค่าภาษีรถยนต์</strong>
                                </label>
                                <div className="col-md-3">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.car_cost_tax}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>
                              </>
                            )
                          ) : null}

                          <label className="col-md-3">
                            <strong> ค่าคอมมิชชั่น/ค่าแนะนำซื้อรถเข้า </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car.car_cost_commissions}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ค่าใช้จ่ายอื่นๆ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car.car_cost_expenses_other}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>

                          <label className="col-md-3 hidden">
                            <strong> รายรับอื่นๆจากการขาย </strong>
                          </label>
                          <div className="col-md-3 hidden">
                            <span className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car.car_cost_recipe_other}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>
                        </div>

                        {form_controls.length > 0 ? (
                          form_controls.filter(
                            (form_control) =>
                              form_control.field_name === "cost_operation"
                          )[0].visibility === 0 ? null : (
                            <>
                              <div
                                className=" form-group row"
                                style={styles.bottomLine}
                              >
                                <label className="col-md-3 ">
                                  <strong> ค่าดำเนินการ </strong>
                                </label>
                                <div className="col-md-3">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_operation}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>

                                <label className="col-md-3 ">
                                  <strong> ค่าบริการ </strong>
                                </label>
                                <div className="col-md-3 ">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_service}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>
                              </div>
                            </>
                          )
                        ) : null}

                        {form_controls.length > 0 ? (
                          form_controls.filter(
                            (form_control) =>
                              form_control.field_name === "cost_porobor_lan"
                          )[0].visibility === 0 ? null : (
                            <>
                              <div
                                className=" form-group row"
                                style={styles.bottomLine}
                              >
                                <label className="col-md-3 ">
                                  <strong> ค่าขนย้าย </strong>
                                </label>
                                <div className="col-md-3">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_transport}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>

                                <label className="col-md-3 ">
                                  <strong> ค่า พรบ. จากลาน </strong>
                                </label>
                                <div className="col-md-3 ">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_porobor_lan}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>
                              </div>
                            </>
                          )
                        ) : null}

                        {form_controls.length > 0 ? (
                          form_controls.filter(
                            (form_control) =>
                              form_control.field_name ===
                              "cost_bangkhab_phasi_lan"
                          )[0].visibility === 0 ? null : (
                            <>
                              <div
                                className=" form-group row"
                                style={styles.bottomLine}
                              >
                                <label className="col-md-3 ">
                                  <strong> ค่าบังคับต่อภาษี จากลาน </strong>
                                </label>
                                <div className="col-md-3">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_bangkhab_phasi_lan}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>

                                <label className="col-md-3 ">
                                  <strong>
                                    {" "}
                                    {PORT === 9043
                                      ? "ค่าบังคับโอนเข้า A.T. จากลาน "
                                      : "ค่าบังคับโอนเข้าเต็นท์จากลาน "}{" "}
                                  </strong>
                                </label>
                                <div className="col-md-3 ">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_bangkhab_xon_lan}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>
                              </div>
                            </>
                          )
                        ) : null}

                        {form_controls.length > 0 ? (
                          form_controls.filter(
                            (form_control) =>
                              form_control.field_name === "cost_check_ton"
                          )[0].visibility === 0 ? null : (
                            <>
                              <div
                                className=" form-group row"
                                style={styles.bottomLine}
                              >
                                <label className="col-md-3 ">
                                  <strong> ค่าเช็คต้น </strong>
                                </label>
                                <div className="col-md-3">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={car.cost_check_ton}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>

                                <label className="col-md-3 hidden">
                                  <strong> xxx </strong>
                                </label>
                                <div className="col-md-3 hidden">
                                  <span className="text-justify text-primary">
                                    <strong>
                                      <NumberFormat
                                        value={0}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"฿"}
                                      />
                                    </strong>
                                  </span>
                                </div>
                              </div>
                            </>
                          )
                        ) : null}

                        {this.state.car_sell_id === 0 ? null : (
                          <>
                            <div
                              className="row"
                              style={styles.bottomLineAndMargin}
                            >
                              <div className="form-group col-sm-2">
                                <h6>ค่าใช้จ่ายการขาย</h6>
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="car_external_commission">
                                  ค่านายหน้า
                                </label>

                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  value={this.state.car_external_commission}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="sales_commission">
                                  ค่าคอมมิชชั่นฝ่ายขาย
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.sales_commission}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="additional_commission">
                                  {getFormControlName(
                                    "additional_commission",
                                    form_controls
                                  )}
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.additional_commission}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="advertising_cost">
                                  ค่าโฆษณา
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.advertising_cost}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="delivery_fee">
                                  ค่าบริการส่งรถ
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.delivery_fee}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">&nbsp;</div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="promotion_fee">
                                  ค่าโปรโมชั่น
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.promotion_fee}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="finance_fee">
                                  ค่าธรรมเนียมไฟแนนท์
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.finance_fee}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="transfer_fee">ค่าโอนรถ</label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.transfer_fee}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="cost_after_sales_service">
                                  บริการหลังการขาย
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={this.state.cost_after_sales_service}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>
                            </div>

                            <div
                              className="row"
                              style={styles.bottomLineAndMargin}
                            >
                              <div className="form-group col-sm-2">
                                <h6>รายรับการขาย</h6>
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="vat_tax_invoice">
                                  vat ยอดจัดได้คืน
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={vat_tax_invoice.toFixed(0)}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                <label htmlFor="tax_commission">
                                  ค่าคอมมิชชั่นไฟแนนท์
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={tax_commission.toFixed(0)}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>
                              <div className="form-group col-sm-2">
                                <label htmlFor="vat_commission">
                                  VAT ค่าคอมมิชชั่น
                                </label>
                                <NumberFormat
                                  className="form-control"
                                  thousandSeparator={true}
                                  value={vat_tax_commission.toFixed(0)}
                                  displayType={"text"}
                                  prefix={"฿"}
                                  min={0}
                                  max={1000000000}
                                  step={1000}
                                  size={10}
                                  allowNegative={false}
                                />
                              </div>

                              <div className="form-group col-sm-2">
                                {" "}
                                &nbsp;{" "}
                              </div>
                              <div className="form-group col-sm-2">
                                {" "}
                                &nbsp;{" "}
                              </div>
                              <div className="form-group col-sm-2">
                                {" "}
                                &nbsp;
                                {/*<Button type="button" onClick={this.toggleCarSellPriceEdit}
                                                          className="btn btn-warning float-right">
                                                    <i className="icon-note"></i>&nbsp;&nbsp;แก้ไขรับ-จ่ายการขาย
                                                  </Button>*/}
                              </div>
                            </div>
                          </>
                        )}

                        <div
                          className={
                            this.state.user.type === "admin"
                              ? " form-group row"
                              : " hidden"
                          }
                        >
                          <label className="col-md-3 text-danger h4">
                            <strong> {text_sum_cost} </strong>
                          </label>
                          <div className="col-md-3 offset-6">
                            <span className="text-justify text-danger h4">
                              <strong>
                                <NumberFormat
                                  value={cost_all.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.user.type === "admin"
                              ? " form-group row"
                              : " hidden"
                          }
                        >
                          <label className="col-md-3 text-primary h4">
                            <strong> รวมขาย </strong>
                          </label>
                          <div className="col-md-3 offset-6">
                            <span className="text-justify text-primary h4">
                              <strong>
                                <NumberFormat
                                  value={sell_all.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.user.type === "admin"
                              ? " form-group row"
                              : " hidden"
                          }
                        >
                          <label className="col-md-3 text-warning h4">
                            <strong> ตั้งหนี้ </strong>
                          </label>
                          <div className="col-md-3 offset-6">
                            <span className="text-justify text-warning h4">
                              <strong>
                                <NumberFormat
                                  value={-amount_of_debt.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.user.type === "admin"
                              ? " form-group row"
                              : " hidden"
                          }
                        >
                          <label className="col-md-3 text-success h4">
                            <strong> กำไรสุทธิ </strong>
                          </label>
                          <div className="col-md-3 offset-6">
                            <span className="text-justify text-success h4">
                              <strong>
                                <NumberFormat
                                  value={profit.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"฿"}
                                />
                              </strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Modal
                  isOpen={this.state.toggle_car_edit_price}
                  toggle={this.toggleCarEditPrice}
                  className={"modal-lg " + this.props.className}
                  style={width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }}
                >
                  <ModalBody>
                    <CarEditPrice
                      car={car}
                      port={port}
                      user_type={this.state.user.type}
                      username={this.state.user.user}
                      onLoadCarById={() => {
                        this.loadCarById();
                      }}
                      onToggle={this.toggleCarEditPrice}
                      form_controls={this.state.form_controls}
                    />
                  </ModalBody>
                </Modal>
              </div>
            </div>
          </TabPane>

          <TabPane tabId="2">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">อุปกรณ์เสริมอื่นๆ</strong>
                  </div>

                  {Object.keys(this.state.car).length !== 0 ? (
                    <CarFeatureForm
                      car_id={this.state.car_id}
                      car_feature_other={this.state.car.car_feature_other}
                      web_youtube_link={this.state.car.web_youtube_link}
                      web_tiktok_link={this.state.car.web_tiktok_link}
                      onLoadCarById={() => {
                        this.loadCarById();
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </TabPane>

          <TabPane tabId="3">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      ข้อมูลเจ้าของเดิมลำดับล่าสุด{" "}
                    </strong>

                    {checkGroupPermission(20, this.state.grouppermissions)
                      .modified ? (
                      <Button
                        type="button"
                        onClick={this.togglePrimaryCarEditOldOwner}
                        className="btn btn-warning float-right"
                      >
                        <i className="icon-note"></i>
                        &nbsp;&nbsp;แก้ไขข้อมูลเจ้าของรถ
                      </Button>
                    ) : null}

                    <Modal
                      isOpen={this.state.primarycareditowner}
                      toggle={this.togglePrimaryCarEditOldOwner}
                      className={"modal-lg " + this.props.className}
                      style={
                        width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }
                      }
                    >
                      <ModalBody>
                        <CarEditOldOwner
                          onToggle={this.togglePrimaryCarEditOldOwner}
                          car={this.state.car}
                          onLoadCarById={() => {
                            this.loadCarById();
                          }}
                        />
                      </ModalBody>
                    </Modal>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">
                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ลำดับที่ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong>
                                {car.car_owner_old_order === 0
                                  ? "-"
                                  : car.car_owner_old_order}
                              </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ชื่อ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_name_owner_old} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> นามสกุล </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_lastname_owner_old} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> เลขบัตรประจำตัวประชาชน </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_id_card} </strong>
                            </span>
                          </div>

                          <label className="col-md-3 ">
                            <strong> เบอร์โทรศัพท์ </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_telephone_old} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ป้ายทะเบียนเดิม </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.car_license_plate_old} </strong>
                            </span>
                          </div>

                          <label className="col-md-3">
                            <strong> จังหวัด </strong>
                          </label>
                          <div className="col-md-3">
                            <span className="text-justify text-primary">
                              <strong> {car.province_name_old} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ที่อยู่ตามทะเบียนบ้าน </strong>
                          </label>
                          <div className="col-md-9">
                            <span className="text-justify text-primary">
                              <strong> {car.car_address_old} </strong>
                            </span>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> หมายเหตุ </strong>
                          </label>
                          <div className="col-md-9">
                            <span className="text-justify text-primary">
                              <strong> {car.car_other} </strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      ข้อมูลเจ้าของเดิม (ที่ไม่ใช่เจ้าของล่าสุด){" "}
                    </strong>

                    {checkGroupPermission(20, this.state.grouppermissions)
                      .created ? (
                      <button
                        className="btn btn-info float-right"
                        onClick={() => {
                          this.setState({
                            isModalCarOwner: true,
                            actionCarOwner: "add",
                          });
                        }}
                      >
                        <i className="icon-plus" />
                        &nbsp; เพิ่มข้อมูลเจ้าของเดิม
                      </button>
                    ) : null}
                  </div>
                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">
                        <CarOwnerForm
                          isModal={this.state.isModalCarOwner}
                          action={this.state.actionCarOwner}
                          toggle={() => {
                            this.setState({
                              isModalCarOwner: !this.state.isModalCarOwner,
                            });
                          }}
                          car_id={this.state.car_id}
                          carOwner={this.state.carOwner}
                          user={this.state.user.user}
                          reload={() => this.loadCarOwnerData()}
                        />

                        {/*<CarOwnerList
                                    ownerLists={this.state.ownerLists}
                                  />*/}

                        <div>
                          <table
                            className={
                              this.state.ownerLists.length > 0
                                ? "table table-striped "
                                : "table table-striped hidden"
                            }
                          >
                            <thead>
                              <tr>
                                <th className="text-center">ลำดับที่</th>
                                <th className="text-center">
                                  ข้อมูลชื่อเจ้าของเดิม
                                </th>
                                <th className="text-center">ข้อมูลรถ</th>
                                <th className="text-center">&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.ownerLists.map((owner, index) => (
                                <tr key={index}>
                                  <td className="text-center">
                                    {owner.owner_order}
                                  </td>
                                  <td className="text-left">
                                    ชื่อ-นามสกุล: {owner.owner_name}
                                    <br />
                                    ที่อยู่: {owner.owner_address} <br />
                                    หมายเลขโทรศัพท์:{" "}
                                    {owner.owner_phone === ""
                                      ? "-"
                                      : owner.owner_phone}
                                  </td>
                                  <td className="text-left">
                                    หมายเลขทะเบียน: {owner.car_license} จังหวัด:{" "}
                                    {owner.province_name}
                                    <br />
                                    วันที่จดทะเบียน:{" "}
                                    {owner.owner_registration === "0000-00-00"
                                      ? "-"
                                      : moment(owner.owner_registration).format(
                                          "YYYY-MM-DD"
                                        )}
                                  </td>
                                  <td className="text-center">
                                    <button
                                      className="btn btn-sm btn-warning mr-2"
                                      onClick={() => {
                                        this.setState({
                                          isModalCarOwner: true,
                                          actionCarOwner: "edit",
                                          carOwner: owner,
                                        });
                                      }}
                                    >
                                      <i className="fa fa-edit" /> แก้ไข
                                    </button>

                                    <button
                                      className="btn btn-sm btn-danger btn-md-width"
                                      onClick={() =>
                                        this.onDeleteCarOwner(owner)
                                      }
                                    >
                                      <i className="fa fa-remove" /> ลบ
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div
                            className={
                              this.state.ownerLists.length === 0
                                ? " text-center  "
                                : "hidden"
                            }
                          >
                            <strong className="text-danger">ไม่พบรายการ</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>

          <TabPane tabId="4">
            <CarEditAlbum
              car={car}
              upload_code={this.state.upload_code}
              menuID={21}
              grouppermissions={this.state.grouppermissions}
            />
          </TabPane>

          <TabPane tabId="5">
            <CarDocList
              car={this.state.car}
              menuID={22}
              car_id={this.state.car_id}
              grouppermissions={this.state.grouppermissions}
              car_doc_type={"normal"}
              width={width}
            />
          </TabPane>

          <TabPane tabId="6">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">ค่าซ่อมบำรุง</strong>

                    {checkGroupPermission(3, this.state.grouppermissions)
                      .created ? (
                      <button
                        className="btn btn-info float-right"
                        onClick={this.pushToCarRepairNew}
                      >
                        <i className="icon-plus" />
                        &nbsp; เพิ่มข้อมูลการซ่อม
                      </button>
                    ) : null}

                    {checkGroupPermission(3, this.state.grouppermissions)
                      .printed ? (
                      <button
                        type="button"
                        style={{ width: 80 }}
                        className="btn btn-success float-right mr-2"
                        onClick={() => this.exportCarRepairData()}
                      >
                        {" "}
                        Excel{" "}
                      </button>
                    ) : null}
                  </div>
                  <div className="card-block">
                    <CarRepairListItem
                      lists={this.state.car_repair_list}
                      onCarRepairDelete={this.onCarRepairDelete}
                      onCarRepairEditSelected={this.onCarRepairEditSelected}
                      onCarRepairUploadFile={this.onCarRepairUploadFile}
                      user_type={this.state.user.type}
                      menuID={23}
                      grouppermissions={this.state.grouppermissions}
                      onSearchByRepairType={this.loadCarRepairByRepairType}
                      sell_status_check={this.state.sell_status_check}
                    />
                  </div>

                  <Modal
                    isOpen={this.state.toggle_delete_car_repair}
                    toggle={this.toggleCarRepairDelete.bind(this)}
                    className={"modal-danger "}
                  >
                    <ModalHeader toggle={this.toggleCarRepairDelete.bind(this)}>
                      ลบรายการซ่อมบำรุง
                    </ModalHeader>
                    <ModalBody>
                      <strong> คุณต้องการลบข้อมูล ใช่หรือไม่ ?? </strong>
                      <br />
                      (ข้อมูลจะไม่สามารถกู้คืนได้)
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="primary"
                        onClick={this.carRepairDeleteConfirm.bind(
                          this,
                          this.state.car_repair
                        )}
                      >
                        ตกลง
                      </Button>{" "}
                      <Button
                        color="secondary"
                        onClick={this.toggleCarRepairDelete.bind(this)}
                      >
                        ยกเลิก
                      </Button>
                    </ModalFooter>
                  </Modal>

                  {Object.keys(this.state.car_repair).length === 0 ? null : (
                    <CarRepairFile
                      toggle={this.state.toggle_car_repair_file}
                      onToggle={this.toggleCarRepairFile}
                      width={width}
                      car_repair={this.state.car_repair}
                      onReload={() => {
                        this.loadCarById();
                        this.loadCarRepairData();
                      }}
                    />
                  )}

                  <Modal
                    isOpen={this.state.toggle_car_repair_edit}
                    toggle={this.toggleCarRepairEdit}
                    className={"modal-lg "}
                    style={
                      width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }
                    }
                  >
                    <ModalBody>
                      <CarRepairEditForm
                        is_date_fill={this.state.is_date_fill}
                        onToggle={this.toggleCarRepairEdit}
                        onCarRepairSubmit={{
                          edit: this.updateCarRepairNoFile.bind(this),
                          cancel: this.toggleCarRepairEdit,
                        }}
                        car={this.state.car}
                        car_repair={this.state.car_repair}
                      />
                    </ModalBody>
                  </Modal>
                </div>
              </div>
            </div>
          </TabPane>

          <TabPane tabId="7">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      ค่าใช้จ่ายอื่นๆ ของรถ
                    </strong>

                    {checkGroupPermission(24, this.state.grouppermissions)
                      .created ? (
                      <button
                        className="btn btn-info float-right"
                        onClick={this.toggleCarExpenseForm}
                      >
                        <i className="icon-plus" />
                        &nbsp; เพิ่มค่าใช้จ่ายอื่นๆ ของรถ
                      </button>
                    ) : null}

                    {this.state.user.type === "admin" ||
                    this.state.user.type === "manager" ? (
                      <button
                        type="button"
                        style={{ width: 80 }}
                        className="btn btn-success float-right mr-2"
                        onClick={() => this.exportCarExpensesOtherData()}
                      >
                        Excel
                      </button>
                    ) : null}
                  </div>

                  <div className="card-block">
                    <CarExpenseList
                      car_expense_list={car_expense_list}
                      company_setting={this.state.company_setting}
                      onReload={this.loadCarExpenseData}
                      car_id={this.state.car_id}
                      menuID={24}
                      expense_type_id={1}
                      grouppermissions={this.state.grouppermissions}
                      form_controls={this.state.form_control_expense_cars}
                      sell_status_check={this.state.sell_status_check}
                    />
                  </div>
                </div>
              </div>

              <Modal
                isOpen={this.state.toggle_car_expense}
                toggle={this.toggleCarExpenseForm}
                className={"modal-lg " + this.props.className}
                style={width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }}
              >
                <ModalBody>
                  <CarExpenseForm
                    car_id={this.state.car_id}
                    expense_type_id={1}
                    company_setting={this.state.company_setting}
                    onToggle={this.toggleCarExpenseForm}
                    onReload={this.loadCarExpenseData}
                    isDateFill={this.state.is_date_fill}
                    form_controls={this.state.form_control_expense_cars}
                  />
                </ModalBody>
              </Modal>
            </div>
          </TabPane>

          <TabPane tabId="8">
            <CarDocList
              car={this.state.car}
              menuID={22}
              car_id={this.state.car_id}
              grouppermissions={this.state.grouppermissions}
              car_doc_type={"secret"}
              width={width}
            />
          </TabPane>

          <TabPane tabId="9">
            {this.state.car_id !== "" &&
            Object.keys(this.state.car).length > 0 ? (
              <CarRepairAfterSell
                is_after_sell={1}
                grouppermissions={this.state.grouppermissions}
                menuID={28}
                car_id={this.state.car_id}
                history={this.props.history}
                user_type={this.state.user.type}
                car={this.state.car}
                width={width}
                is_date_fill={this.state.is_date_fill}
              />
            ) : null}
          </TabPane>

          <TabPane tabId="10">
            {this.state.activeTab === "10" && (
              <CarDocList
                car={this.state.car}
                menuID={29}
                car_id={this.state.car_id}
                grouppermissions={this.state.grouppermissions}
                car_doc_type={"sell_doc"}
                width={width}
              />
            )}
          </TabPane>

          <TabPane tabId="11">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      ค่าใช้จ่ายในการขาย(ของรถ){" "}
                    </strong>

                    {checkGroupPermission(36, this.state.grouppermissions)
                      .created ? (
                      <button
                        className="btn btn-info float-right"
                        onClick={this.toggleCarExpenseFormSell}
                      >
                        <i className="icon-plus" />
                        &nbsp; เพิ่มค่าใช้จ่ายในการขาย
                      </button>
                    ) : null}

                    {/*{
                              this.state.user.type === 'admin' || this.state.user.type === 'manager' ?
                                <button type="button" style={{width: 80}}
                                        className="btn btn-success float-right mr-2"
                                        onClick={() => this.exportCarExpensesOtherData()}>
                                  Excel
                                </button>
                                : null
                            }*/}
                  </div>

                  <div className="card-block">
                    <CarExpenseList
                      car_expense_list={this.state.car_expense_sell_list}
                      company_setting={this.state.company_setting}
                      onReload={this.loadCarExpenseSellData}
                      car_id={this.state.car_id}
                      menuID={36}
                      expense_type_id={4}
                      grouppermissions={this.state.grouppermissions}
                      form_controls={this.state.form_control_expense_cars}
                      sell_status_check={this.state.sell_status_check}
                    />
                  </div>
                </div>
              </div>

              <Modal
                isOpen={this.state.toggle_car_expense_sell}
                toggle={this.toggleCarExpenseFormSell}
                className={"modal-lg " + this.props.className}
                style={width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }}
              >
                <ModalBody>
                  <CarExpenseForm
                    car_id={this.state.car_id}
                    expense_type_id={4}
                    company_setting={this.state.company_setting}
                    onToggle={this.toggleCarExpenseFormSell}
                    onReload={this.loadCarExpenseSellData}
                    isDateFill={this.state.is_date_fill}
                    form_controls={this.state.form_control_expense_cars}
                  />
                </ModalBody>
              </Modal>
            </div>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const styles = {
  bottomLine: {
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
    borderWidth: 0.5,
  },
  toUpper: {
    textTransform: "uppercase",
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  type: state.auth.type,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(CarDetail);
